/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  View,
  StyleSheet,
  Dimensions,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import { debounce } from 'lodash';
import { Formik } from 'formik';
import { addDays } from 'date-fns';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import { buttonFloating } from '@/assets/styles/buttonStyles';
import * as Layout from '@components/screen/Layout';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isAndroid, isWebPlatform } from '@global/screens';
import {
  getAttibutes,
  getUniqeItem,
  isVn,
  generateUUIDv4,
} from '@global/helpers';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import SelectBox from '@components/form/SelectBox';
import DatePicker from '@components/form/DatePicker';
import RadioButton from '@components/form/RadioButton';
import CheckBox from '@components/form/CheckBox';
import SelectProductV2 from '@components/form/SelectProductV2';
import CustomerClusterSearch from '@components/form/search/CustomerClusterSearch';
import BudgetPocketSearch from '@components/form/search/BudgetPocketSearch';
import SociollaErrorMessage from '@components/sociolla/form/SociollaErrorMessage';
import Alert from '@components/global/Alert';
import Image from '@components/global/Image';
import ModalFull from '@components/modal/ModalFull';
import SearchInputMobile from '@components/global/SearchInputMobile';
import ScrollContainer from '@components/global/ScrollContainer';
import SalesTeamSearch from '@components/form/search/SalesTeamSearch';
import RenderIf from '@components/global/RenderIf';

import SelectItem from '@/screens/setting/promotion-rules/components/SelectItem';
import SelectFormRules from '@/screens/setting/promotion-rules/components/SelectFormRules';
import SelectRangeRules from '@/screens/setting/promotion-rules/components/SelectRangeRules';

import SelectFormRulesMobile from '@/screens/setting/promotion-rules/components/SelectFormRulesMobile';
import ProductResult from '@/screens/setting/promotion-rules/components/ProductResult';
import ButtonUploadCSV from '@/screens/setting/promotion-rules/components/ButtonUploadCSV';

import useApi from '@/hooks/useApi';
import * as Resources from '@/store/resources/actions';
import { MsOrder } from '@api/ms-order';
import { MsCatalog } from '@api/ms-catalog';
import { MsB2b } from '@api/ms-b2b';
import { MsAccount } from '@api/ms-account';
import { showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';

import { MAX_QUANTITY_FREE_PRODUCTS } from '@/constants';

const { height: windowHeight } = Dimensions.get('window');
const dimension = Dimensions.get('screen');

const keyDefault = {
  customer: false,
  brand: false,
  category: false,
  product: false,
  free_product: false,
};

const skipDefault = {
  customer: 0,
  brand: 0,
  category: 0,
  product: 0,
  free_product: 0,
};

const keywordDefault = {
  customer: '',
  brand: '',
  category: '',
  product: '',
  free_product: '',
};

const PromotionRulesFormScreen = (props) => {
  const dispatch = useDispatch();
  const promotionTypes = useSelector((state) => state.global.promotionTypes);
  const promotionModels = useSelector((state) => state.global.promotionModels);
  const markettypes = useSelector((state) => state.resources.marketTypes);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [selectedMarketType, setSelectedMarketType] = useState({});
  const [selectedBusinessType, setSelectedBusinessType] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectRange, setselectRange] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedFreeProduct, setSelectedFreeProduct] = useState({});
  const [promotionTypeList, setPromotionTypeList] = useState([]);
  const [promotionModelList, setPromotionModelList] = useState([]);
  const [detailData, setDetailData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [customerSpecificType, setCustomerSpecificType] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState([]);

  const [showRules, setShowRules] = useState('');
  const [rulesType, setRulesType] = useState('');
  const [titleModal, setTitleModal] = useState('');
  const [stepModal, setStepModal] = useState(1);
  const [listModal, setListModal] = useState([]);
  const [listfiltered, setListFiltered] = useState([]);
  const [searchType, setSearchType] = useState('');
  const [listCustomer, setListCustomer] = useState([]);
  const [listBrand, setListBrand] = useState([]);
  const [listCategory, setListCategory] = useState([]);
  const [listProduct, setListProduct] = useState([]);
  const [listFreeProduct, setListFreeProduct] = useState([]);
  const [selectedBoxCustomer, setSelectedBoxCustomer] = useState([]);
  const [selectedBoxBrand, setSelectedBoxBrand] = useState([]);
  const [selectedBoxCategory, setSelectedBoxCategory] = useState([]);
  const [selectedBoxProduct, setSelectedBoxProduct] = useState([]);
  const [selectedBoxRange, setSelectedBoxRange] = useState([]);
  const [showList, setShowList] = useState(keyDefault);
  const [searchKeyword, setSearchKeyword] = useState(keywordDefault);
  const [skip, setSkip] = useState(skipDefault);
  const [isEmpty, setIsEmpty] = useState(keyDefault);
  const [isLoading, setIsLoading] = useState(keyDefault);
  const [isLoadingMore, setIsLoadingMore] = useState(keyDefault);
  const [showAddRange, setshowAddRange] = useState(false);
  const [gwpLevelingData, setGwpLevelingData] = useState({
    minimum_requirement: '',
    purchase_product_by: '',
  });
  const [levelProductGwp, setLevelProductGwp] = useState({
    purchaseProduct: [],
    freeProduct: [],
  });
  const [listPurchaseProductGwp, setListPurchaseProductGwp] = useState([]);
  const [listFreeProductGwp, setListFreeProductGwp] = useState([]);
  const [listBrandGwp, setListBrandGwp] = useState([]);

  const getCustomers = useApi(MsB2b.getCustomersFromEs);
  const getBrands = useApi(MsCatalog.getBrands);
  const getCategories = useApi(MsCatalog.getCategories);
  const getProducts = useApi(MsCatalog.getProducts);
  const getProductsFromEs = useApi(MsB2b.getProductsFromEs);
  const getPromotionRulesDetail = useApi(MsOrder.getPromotionRulesDetail);
  const getCustomerTypeApi = useApi(MsAccount.getCustomerTypes);

  const ScrollMobile = isWeb ? View : ScrollContainer;

  useEffect(() => {
    async function fetchCustomerTypes() {
      try {
        const res = await getCustomerTypeApi.request({
          params: {
            filter: {
              is_active: true,
            },
            fields: 'name,description,_id',
          },
        });
        if (res?.status === 200 && res.data?.data?.length) {
          const types = res.data.data.map((item) => ({
            value: {
              _id: item._id,
              name: item.name,
              description: item.description,
            },
            label: item.name,
          }));
          setCustomerSpecificType(types);
        } else {
          setCustomerSpecificType([]);
        }
      } catch (e) {
        console.error('Failed to fetch customer types', e);
        setCustomerSpecificType([]);
      }
    }

    fetchCustomerTypes();
  }, []);

  // promoriones rules validation
  const FormValidationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required.'),
    description: Yup.string().required('Description is required.'),
    from_date: Yup.string().required('From Date is required.'),
    to_date: Yup.string().required('To Date is required.'),
    promotion_type: Yup.object().required('Promotion Type is required.'),
    promotion_model: Yup.object().required('Promotion Model is required.'),
    budget: Yup.object().when(
      ['promotion_model', 'current_status'],
      (model_value, current_status_value) => {
        if (
          ['extra_discount'].includes(model_value?.value) &&
          current_status_value != 'draft'
        ) {
          return Yup.object().required('Budget Pocket is required.');
        }
        return Yup.object();
      },
    ),
    cluster: Yup.object().when('promotion_model', (model_value) => {
      if (model_value?.value == 'regular_discount') {
        return Yup.object().required('Cluster is required.');
      }
      return Yup.object();
    }),
    no_of_transactions: Yup.string().when('promotion_model', (model_value) => {
      if (
        !['regular_discount', 'cash_before_delivery'].includes(
          model_value?.value,
        )
      ) {
        return Yup.string().required('No of Transaction is required.');
      }
      return Yup.string();
    }),
    maximum_applied_per_customer: Yup.string().when(
      'promotion_model',
      (model_value) => {
        if (
          !['regular_discount', 'cash_before_delivery'].includes(
            model_value?.value,
          )
        ) {
          return Yup.string().required(
            'Max. Applied per Customer is required.',
          );
        }
        return Yup.string();
      },
    ),
    maximum_qty_order: Yup.string().when('promotion_model', (model_value) => {
      if (model_value?.value == 'buy_x_get_x_and_buy_x_get_y') {
        return Yup.string().required('Max. Quantity Order is required.');
      }
      return Yup.string();
    }),
    maximum_qty_order_type: Yup.mixed().when(
      'condition_buy_x_get_x',
      (cond) => {
        if (cond?.value == 'gwp_leveling') {
          return Yup.mixed().required(
            'Max Quantity Free Product Type is required',
          );
        }
        return Yup.mixed();
      },
    ),
    deduction_percentage: Yup.number().when(
      ['promotion_model', 'percentage_type'],
      (model_value, percent_type) => {
        if (
          model_value?.value == 'extra_discount' &&
          percent_type?.value == 'all'
        ) {
          return Yup.number().required('Percent Discount is required.');
        }
        return Yup.number();
      },
    ),
    first_order_deduction_percentage: Yup.number().when(
      ['promotion_model', 'percentage_type'],
      (model_value, percent_type) => {
        if (
          model_value?.value == 'extra_discount' &&
          percent_type?.value == 'specific_order'
        ) {
          return Yup.number().required('First Order is required.');
        }
        return Yup.number();
      },
    ),
    next_order_deduction_percentage: Yup.number().when(
      ['promotion_model', 'percentage_type'],
      (model_value, percent_type) => {
        if (
          model_value?.value == 'extra_discount' &&
          percent_type?.value == 'specific_order'
        ) {
          return Yup.number().required('Next Order is required.');
        }
        return Yup.number();
      },
    ),
    gwp_levelling_min_quantity: Yup.number(),
    gwp_levelling_min_amount: Yup.number(),
  });

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setSearchKeyword(keywordDefault);
      setSkip(skipDefault);
      setIsEmpty(keyDefault);
      setIsLoading(keyDefault);
      setIsLoadingMore(keyDefault);
      setShowList(keyDefault);
    }
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    if (mounted && skip[rulesType] > 0) {
      onSearchRules(searchType, searchKeyword[rulesType]);
    }
    return () => {
      mounted = false;
    };
  }, [skip]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (stepModal == 1) {
        if (showRules == 'sales_team') {
          setTitleModal('Sales Team');
          setListModal(salesTeamTypes);
        } else if (showRules == 'customer') {
          setTitleModal('Customers');
          setListModal(customerTypes);
        } else if (showRules == 'product') {
          setTitleModal('Product');
          setListModal(productTypes);
        }
      } else if (stepModal == 2) {
        if (rulesType == 'specific_sales_team') {
          setTitleModal('Select Specific Sales Team');
        } else if (rulesType == 'specific_market_business_type') {
          setListFiltered(markettypes);
          setTitleModal('Select Market Type');
        } else if (rulesType == 'specific_customer') {
          setListFiltered([]);
          setTitleModal('Select Specific Customer');
        } else if (rulesType == 'specific_brand') {
          setListFiltered([]);
          setTitleModal('Select Specific Brand');
        } else if (rulesType == 'specific_categories') {
          setListFiltered([]);
          setTitleModal('Select Specific Categories');
        } else if (rulesType == 'specific_product') {
          setListFiltered([]);
          setTitleModal('Select Specific Products');
        }
      } else if (stepModal == 3) {
        if (rulesType == 'specific_market_business_type') {
          setTitleModal('Select Business Type');
        }
      }
      if (!showRules) {
        setRulesType('');
        setTitleModal('');
        setStepModal('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [stepModal, showRules, rulesType]);

  const salesTeamTypes = [
    { label: isWeb ? 'All' : 'All Sales Team', value: 'all' },
    { label: 'Specific Sales Team', value: 'specific_sales_team' },
  ];

  const customerTypes = [
    { label: isWeb ? 'All' : 'All Customer', value: 'all' },
    {
      label: 'Specific Market Type & Business Type',
      value: 'specific_market_business_type',
    },
    { label: 'Specific Customer', value: 'specific_customer' },
    { label: 'Specific Cluster', value: 'specific_cluster' },
    { label: 'Customer Type', value: 'specific_customer_type' },
  ];

  const productTypes = [
    { label: isWeb ? 'All' : 'All Product', value: 'all' },
    { label: 'Specific Brand', value: 'specific_brand' },
    { label: 'Specific Categories', value: 'specific_categories' },
    { label: 'Specific Product', value: 'specific_product' },
  ];

  const ExtradiscountTypes = [
    { label: isWeb ? 'All' : 'All', value: 'all' },
    { label: 'Specific Order', value: 'specific_order' },
    { label: 'Specific Quantity Order', value: 'specific_quantity_order' },
    { label: 'Specific Amount Order', value: 'specific_amount_order' },
  ];

  const conditionBuyxgetx = [
    {
      label: isWeb ? 'Quantity Purchased' : 'Quantity Purchased',
      value: 'quantity_purchased',
    },
    { label: 'Minimum Purchased', value: 'minimum_purchased' },
    { label: 'GWP Leveling', value: 'gwp_leveling' },
  ];

  const minimumRequirementOptions = [
    { label: 'Amount', value: 'amount' },
    { label: 'Quantity Purchased', value: 'quantity' },
  ];

  const purchaseProductByOptions = [
    { label: 'Brand', value: 'brand' },
    { label: 'Product', value: 'product' },
  ];

  // show add Range popup
  const onRangeSelect = (val = {}) => {
    setshowAddRange(true);
  };

  // show add range popup
  const onCloseRange = () => {
    setshowAddRange(false);
  };

  // convert initial form value
  const convertDetailValue = (result) => {
    if (result?.discount_info?.free_products?.id && !selectedFreeProduct?.id) {
      setSelectedFreeProduct(result.discount_info.free_products);
    }
    if (result?.rules) {
      if (result.rules?.market_types?.length && !selectedMarketType?.length) {
        const mtData = result.rules.market_types[0];
        setSelectedMarketType(convertSelectedMarketType(mtData));
        if (mtData?.business_types?.length) {
          setSelectedBusinessType(
            getUniqeItem(
              mtData.business_types.map((item) => {
                return convertBusinessType(item);
              }),
            ),
          );
        }
        const findData = markettypes.find((a) => a.code == mtData.name);
        if (findData?.business_type?.length) {
          setBusinessTypeList(
            findData.business_type.map((item) => {
              return convertBusinessType(item);
            }),
          );
        }
      }
      if (result.rules?.customers?.length && !selectedCustomer?.length) {
        setSelectedCustomer(getUniqeItem(result.rules.customers));
      }
      if (
        result.rules?.customer_types?.length &&
        !selectedCustomerType?.length
      ) {
        const types = result.rules.customer_types.map((item) => {
          const match = customerSpecificType.find(
            (ct) => ct.value._id === item.customer_type_id,
          );
          return (
            match || {
              value: {
                _id: item.customer_type_id,
                name: item.name,
                description: item.description,
              },
              label: item.name,
            }
          );
        });
        setSelectedCustomerType(types);
      }
      if (result.rules?.brands?.length && !selectedBrand?.length) {
        setSelectedBrand(getUniqeItem(result.rules.brands));
      }
      if (result.rules?.categories?.length && !selectedCategory?.length) {
        setSelectedCategory(getUniqeItem(result.rules.categories));
      }
      if (result.rules?.products?.length && !selectedProduct?.length) {
        setSelectedProduct(
          getUniqeItem(result.rules.products, 'id', 'combination_id'),
        );
      }
    }
    if (result?.discount_info?.specific_quantity_order?.length) {
      setselectRange(
        result?.discount_info?.specific_quantity_order?.map((item) => {
          return {
            from_qty: item.from_qty,
            to_qty: item.to_qty,
            deduction_percentage: item.deduction_percentage,
          };
        }),
      );
    }
    if (result?.discount_info?.specific_amount_order?.length) {
      setselectRange(
        result?.discount_info?.specific_amount_order?.map((item) => {
          return {
            from_amount: item.from_amount,
            to_amount: item.to_amount,
            deduction_percentage: item.deduction_percentage,
          };
        }),
      );
    }
  };

  // convert market type value
  const convertSelectedMarketType = (item) => {
    const m_value = item.code ? item.code : item.name;
    return {
      id: item.id,
      code: m_value,
      name: m_value,
      value: m_value,
    };
  };

  // convert business type value
  const convertBusinessType = (item) => {
    const b_value = item.code ? item.code : item.name;
    return {
      id: item.id ? item.id : item._id,
      name: b_value,
      code: b_value,
      label: b_value,
      value: b_value,
    };
  };

  // get detail promotion rules
  const getDetail = async (id) => {
    const response = await getPromotionRulesDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      convertDetailValue(result);
      setDetailData(result);
      if (result.rules.is_gwp_levelling) {
        setGwpLevelingData({
          minimum_requirement: result.rules.gwp_levelling_type,
          purchase_product_by: result.rules.gwp_levelling_purchase_type,
        });
        result.maximum_qty_order_type =
          result.rules.maximum_qty_order_type == 'bundle'
            ? MAX_QUANTITY_FREE_PRODUCTS[0]
            : MAX_QUANTITY_FREE_PRODUCTS[1];
        const freeProducts =
          result.discount_info.gwp_levelling_free_products?.map((b) => ({
            ...b,
            items: b.products,
          }));
        const productBrand = {
          freeProduct: freeProducts,
        };
        if (result.rules.gwp_levelling_purchase_type == 'product') {
          const purchaseProducts = result.rules.gwp_levelling_products?.map(
            (b) => ({
              ...b,
              items: b.products,
            }),
          );
          productBrand.purchaseProduct = purchaseProducts;
        } else {
          const purchaseBrands = result.rules.gwp_levelling_brands?.map(
            (b) => ({
              ...b,
              items: b.brands,
            }),
          );
          productBrand.purchaseProduct = purchaseBrands;
        }
        setLevelProductGwp(productBrand);
      }
    } else {
      setDetailData({});
    }
    setTimeout(() => {
      setIsReady(true);
    }, 500);
  };

  // reset all rules states
  const resetRules = () => {
    setBusinessTypeList([]);
    setSelectedMarketType({});
    setSelectedBusinessType([]);
    setSelectedCustomer([]);
    setSelectedBrand([]);
    setSelectedCategory([]);
    setSelectedProduct([]);
    setSelectedFreeProduct({});
    setSelectedBoxBrand([]);
  };

  // reset all initial states
  const resetData = () => {
    setIsReady(false);
    setIsEdit(false);
    setDetailData({});
    setPromotionTypeList([]);
    setPromotionModelList([]);
    resetRules();
    setShowRules(false);
  };

  // on search product, free product, customer, brand and category
  const onSearchRules = async (
    type,
    val = '',
    isGwpLeveling = false,
    gwpSkip = 0,
    values = null,
  ) => {
    setIsEmpty({ ...isEmpty, [type]: false });
    if (!isLoadingMore[type]) {
      setIsLoading({ ...isLoading, [type]: true });
    }
    try {
      const params = {
        params: {
          filter: {},
          skip: isGwpLeveling ? gwpSkip : skip[type],
          limit: 10,
        },
      };
      let response = null;
      if (val) {
        params.params.filter.name = { $regex: val, $options: 'i' };
      }
      if (type == 'customer') {
        params.params.fields = '_id name';
        params.params.filter.status = 'approved';
        if (values?.selected_sales_team?.length) {
          params.params.filter['sales_team.id'] = {
            $in: values.selected_sales_team.map((a) => a.id),
          };
        }
        if (val) {
          delete params.params.filter.name;
          params.params.filter['keyword'] = val;
        }
        response = await getCustomers.request(params);
      } else if (type == 'brand') {
        params.params.fields = '_id name';
        if (isVn()) {
          params.params.filter.is_active_in_b2b_vn = true;
        } else {
          params.params.filter.is_active_in_b2b = true;
        }
        response = await getBrands.request(params);
      } else if (type == 'category') {
        params.params.fields = '_id name';
        if (isVn()) {
          params.params.filter.is_active_in_b2b_vn = true;
        } else {
          params.params.filter.is_active_in_b2b = true;
        }
        response = await getCategories.request(params);
      } else if (['product', 'free_product'].includes(type)) {
        params.params.fields =
          '_id id name brand combinations default_combination';
        if (isVn()) {
          params.params.filter.is_active_in_b2b_vn = true;
        } else {
          params.params.filter.is_active_in_b2b = true;
        }
        if (type == 'free_product') {
          params.params.filter.classification = ['gwp_non_sellable'];
        }
        if (val) {
          delete params.params.filter.name;
          params.params.filter['keyword'] = val;
        }
        if (val) {
          response = await getProductsFromEs.request(params);
        } else {
          response = await getProducts.request(params);
        }
      }
      if (response?.status == 200 && response?.data?.data?.length) {
        let result = response.data.data.map((item) => {
          if (item._id && ['customer', 'brand', 'category'].includes(type)) {
            item.id = item._id;
          }
          return item;
        });
        if (['product', 'free_product'].includes(type)) {
          const product_temps = [];
          for (let i = 0; i < result.length; i++) {
            const item = result[i];
            if (item?.combinations?.length) {
              for (let j = 0; j < item?.combinations.length; j++) {
                const com = item?.combinations[j];
                product_temps.push({
                  ...item,
                  combination_id: com?._id ? com._id : '',
                  variant: com?.attributes ? getAttibutes(com.attributes) : '',
                  sku: com?.reference ? com.reference : '',
                  image: com?.images?.length ? com.images[0]?.url : '',
                  combination: com,
                });
              }
            }
          }
          result = product_temps;
        }
        if (type == 'customer') {
          if (isLoadingMore[type]) {
            setListCustomer(listCustomer.concat(result));
          } else {
            setListCustomer(result);
          }
        } else if (type == 'brand') {
          if (isLoadingMore[type]) {
            setListBrand(listBrand.concat(result));
          } else {
            setListBrand(result);
          }
        } else if (type == 'category') {
          if (isLoadingMore[type]) {
            setListCategory(listCategory.concat(result));
          } else {
            setListCategory(result);
          }
        } else if (type == 'product') {
          if (isLoadingMore[type]) {
            setListProduct(listProduct.concat(result));
          } else {
            setListProduct(result);
          }
        } else if (type == 'free_product') {
          if (isLoadingMore[type]) {
            setListFreeProduct(listFreeProduct.concat(result));
          } else {
            setListFreeProduct(result);
          }
        }

        if (isGwpLeveling) {
          setIsLoading({ ...isLoading, [type]: false });
          setIsLoadingMore({ ...isLoadingMore, [type]: false });
          return result;
        }
      } else {
        if (!isLoadingMore[type]) {
          if (type == 'customer') {
            setListCustomer([]);
          } else if (type == 'brand') {
            setListBrand([]);
          } else if (type == 'category') {
            setListCategory([]);
          } else if (type == 'product') {
            setListProduct([]);
          } else if (type == 'free_product') {
            setListFreeProduct([]);
          }
        }
        setIsEmpty({ ...isEmpty, [type]: true });
      }
      setIsLoading({ ...isLoading, [type]: false });
      setIsLoadingMore({ ...isLoadingMore, [type]: false });
    } catch (error) {
      if (type == 'customer') {
        setListCustomer([]);
      } else if (type == 'brand') {
        setListBrand([]);
      } else if (type == 'category') {
        setListCategory([]);
      } else if (type == 'product') {
        setListProduct([]);
      } else if (type == 'free_product') {
        setListFreeProduct([]);
      }
      setIsLoading({ ...isLoading, [type]: false });
      setIsLoadingMore({ ...isLoadingMore, [type]: false });
      setIsEmpty({ ...isEmpty, [type]: true });
    }
  };

  // on search specific sales team
  const onSearchModal = useCallback(
    debounce(({ keyword, values }) => {
      try {
        const searchValue = keyword ? keyword.toLowerCase() : '';
        if (rulesType == 'specific_customer') {
          onSearchRules('customer', searchValue, false, 0, values);
        } else if (rulesType == 'specific_product') {
          onSearchRules('product', searchValue);
        }
      } catch (error) {
        console.log('error', error);
      }
    }, 500),
    [rulesType],
  );

  const onChangeActive = async (isActive) => {
    try {
      if (isEdit) {
        await MsOrder.updateStatusActivePromotionRules(detailData?._id, {
          is_active: isActive,
        });
      }
    } catch (error) {}
  };

  const setLevelItems = useCallback((section, level, items) => {
    setLevelProductGwp((prev) => ({
      ...prev,
      [section]: prev[section].map((l) =>
        l.level === level ? { ...l, items } : l,
      ),
    }));
  }, []);

  const addDefaultLevelGwp = (type = 'purchaseProduct') => {
    setLevelProductGwp((prev) => {
      const lastLevel =
        prev[type].length > 0 ? prev[type][prev[type].length - 1].level : 0;

      return {
        ...prev,
        [type]: [
          ...prev[type],
          {
            level: lastLevel + 1,
            items: [],
            ui: {
              // <-- wajib ada
              showList: false,
              searchKeyword: '',
              isLoading: false,
              isLoadingMore: false,
              isEmpty: false,
            },
          },
        ],
      };
    });
  };

  const setLevelUi = (section, level, key, value) => {
    setLevelProductGwp((prev) => ({
      ...prev,
      [section]: prev[section].map((l) =>
        l.level === level ? { ...l, ui: { ...l.ui, [key]: value } } : l,
      ),
    }));
  };

  const resetLevels = () => {
    setLevelProductGwp({
      purchaseProduct: [{ level: 1, items: [] }],
      freeProduct: [{ level: 1, items: [] }],
    });
  };

  const deleteLevel = (sectionType, level) => {
    setLevelProductGwp((prev) => {
      const filteredLevels = prev[sectionType].filter((l) => l.level !== level);
      const renumberedLevels = filteredLevels.map((l, idx) => ({
        ...l,
        level: idx + 1,
      }));

      return {
        ...prev,
        [sectionType]: renumberedLevels,
      };
    });
  };

  const resetGwpLeveling = () => {
    setGwpLevelingData({
      minimum_requirement: '',
      purchase_product_by: '',
    });
    setLevelProductGwp({
      purchaseProduct: [],
      freeProduct: [],
    });
  };

  const resetQtyMinPurchase = () => {
    setSelectedProduct([]);
    setSelectedFreeProduct({});
    setSelectedBrand([]);
  };

  const handleDecimal = (value) => {
    const discountPercentage = value;
    let decimalPlaces;
    if (!isNaN(discountPercentage)) {
      if (Number.isInteger(parseFloat(discountPercentage))) {
        decimalPlaces = 0;
      } else {
        decimalPlaces = 2;
      }
    }
    const formattedValue = parseFloat(value).toFixed(decimalPlaces);
    return formattedValue.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  };

  const conditionGwp = useMemo(() => {
    if (isEdit) {
      if (detailData?.rules?.is_gwp_levelling) {
        return conditionBuyxgetx[2];
      } else {
        if (detailData?.rules?.products?.length) {
          return conditionBuyxgetx[0];
        } else if (detailData?.rules?.brands?.length) {
          return conditionBuyxgetx[1];
        }
      }
    }
    return '';
  }, [detailData]);

  useEffect(() => {
    let mounted = true;
    if (mounted && detailData && Object.keys(detailData).length) {
      convertDetailValue(detailData);
    }
    return () => {
      mounted = false;
    };
  }, [detailData]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      resetData();
      dispatch(Resources.getMarketTypes({ force: true, isAll: true }));
      if (props?.route?.params?.id) {
        setIsEdit(true);
        getDetail(props.route.params.id);
      } else {
        setIsEdit(false);
        setTimeout(() => {
          setIsReady(true);
        }, 500);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  // process promotion types and promotion models lists
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (
        promotionTypes &&
        Object.keys(promotionTypes).length &&
        !promotionTypeList?.length
      ) {
        const types = [];
        const keys = Object.keys(promotionTypes);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          types.push({
            name: promotionTypes[key],
            value: key,
          });
        }
        setPromotionTypeList(types);
      }
      if (
        promotionModels &&
        Object.keys(promotionModels).length &&
        !promotionModelList?.length
      ) {
        const types = [];
        const keys = Object.keys(promotionModels);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          types.push({
            name: promotionModels[key],
            value: key,
          });
        }
        setPromotionModelList(types);
      }
    }
    return () => {
      mounted = false;
    };
  }, [promotionTypes, promotionModels]);

  const handleSubmit = async (values) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    const payload = {
      name: values.name,
      description: values.description,
      from_date: new Date(values.from_date).toISOString(),
      to_date: new Date(values.to_date).toISOString(),
      promotion_type: values.promotion_type?.value
        ? values.promotion_type.value
        : '',
      promotion_model: values.promotion_model?.value
        ? values.promotion_model.value
        : '',
      is_active: values.is_active?.value ? true : false,
      current_status: values.current_status,
      no_of_transactions: values.no_of_transactions
        ? Number(values.no_of_transactions)
        : 0,
      maximum_applied_per_customer: values.maximum_applied_per_customer
        ? Number(values.maximum_applied_per_customer)
        : 0,
      maximum_qty_order: values.maximum_qty_order
        ? Number(values.maximum_qty_order)
        : 0,
      rules: {},
      budget: null,
    };

    if (values.percentage_type.value == 'all') {
      payload.discount_info = {
        discount_type: 'percentage',
        deduction_percentage: Number(
          handleDecimal(values.deduction_percentage),
        ),
        percentage_type: values.percentage_type.value,
      };
    }
    if (values.percentage_type.value == 'specific_order') {
      payload.discount_info = {
        discount_type: 'percentage',
        percentage_type: values.percentage_type.value,
        specific_order: {
          first_order_deduction_percentage: Number(
            handleDecimal(values.first_order_deduction_percentage),
          ),
          next_order_deduction_percentage: Number(
            handleDecimal(values.next_order_deduction_percentage),
          ),
        },
      };
    }
    if (values.percentage_type.value == 'specific_quantity_order') {
      if (!selectedBoxRange?.length) {
        Toast.show({
          text1: 'Please add range for Percent Discount',
          type: 'error',
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
        return;
      }
      payload.discount_info = {
        discount_type: 'percentage',
        percentage_type: 'specific_quantity_order',
        specific_quantity_order: selectedBoxRange.map((item) => {
          return {
            from_qty: item.from_qty,
            to_qty: item.to_qty,
            deduction_percentage: Number(
              handleDecimal(item.deduction_percentage),
            ),
          };
        }),
      };
    }
    if (values.percentage_type.value == 'specific_amount_order') {
      if (!selectedBoxRange?.length) {
        Toast.show({
          text1: 'Please add range for Percent Discount',
          type: 'error',
        });
        dispatch(showPopup({ name: 'isLoading', value: false }));
        return;
      }
      payload.discount_info = {
        discount_type: 'percentage',
        percentage_type: 'specific_amount_order',
        specific_amount_order: selectedBoxRange.map((item) => ({
          from_amount: Number(item.from_amount),
          to_amount: Number(item.to_amount),
          deduction_percentage: Number(
            handleDecimal(item.deduction_percentage),
          ),
        })),
      };
    }
    if (
      ['extra_discount', 'buy_x_get_x_and_buy_x_get_y'].includes(
        payload.promotion_model,
      ) &&
      values.budget?.id
    ) {
      payload.budget = {
        id: values.budget?.id,
        name: values.budget?.name,
      };
    }
    if (payload.promotion_model == 'regular_discount') {
      payload.discount_info.cluster = values.cluster?.id
        ? { id: values.cluster.id, name: values.cluster.name }
        : '';
    } else if (
      ['extra_discount', 'buy_x_get_x_and_buy_x_get_y'].includes(
        payload.promotion_model,
      )
    ) {
      if (values?.selected_sales_team?.length) {
        payload.rules.sales_team = values.selected_sales_team.map((item) => {
          return { id: item.id, name: item.name };
        });
      }
      if (selectedMarketType && Object.keys(selectedMarketType).length) {
        payload.rules.market_types = [
          {
            id: selectedMarketType.id,
            name: selectedMarketType.code,
            business_types: selectedBusinessType?.length
              ? selectedBusinessType
              : [],
          },
        ];
      }
      if (selectedCustomer && Object.keys(selectedCustomer).length) {
        payload.rules.customers = selectedCustomer.map((item) => {
          return { id: item.id, name: item.name };
        });
      }
      if (values?.selected_cluster?.length) {
        payload.rules.clusters = values.selected_cluster.map((item) => {
          return { id: item.id, name: item.name };
        });
      }

      if (selectedCustomerType.length > 0) {
        payload.rules.customer_types = selectedCustomerType.map((item) => {
          return {
            customer_type_id: item.value._id,
            name: item.value.name,
            description: item.value.description,
          };
        });
      }

      if (payload.promotion_model == 'buy_x_get_x_and_buy_x_get_y') {
        if (selectedFreeProduct && Object.keys(selectedFreeProduct).length) {
          const finalProduct = JSON.parse(JSON.stringify(selectedFreeProduct));
          finalProduct.quantity = values.qty_free_product
            ? Number(values.qty_free_product)
            : 1;
          if (
            values.tax_free_product == '' ||
            values.tax_free_product == null ||
            values.tax_free_product == undefined
          ) {
            Toast.show({
              text1: 'Please enter tax of the free product',
              type: 'error',
            });
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
          finalProduct.tax_value = values.tax_free_product
            ? Number(values.tax_free_product)
            : 0;
          payload.discount_info.free_products = finalProduct;
        }
      }
      if (payload.promotion_model == 'buy_x_get_x_and_buy_x_get_y') {
        if (values.is_gwp_levelling) {
          // GWP Levelling

          payload.rules.is_gwp_levelling = true;
          payload.rules.gwp_levelling_purchase_type =
            gwpLevelingData.purchase_product_by;
          payload.rules.gwp_levelling_type =
            gwpLevelingData.minimum_requirement;
          payload.rules.gwp_levelling_min_amount =
            values.gwp_levelling_min_amount;
          payload.rules.gwp_levelling_min_quantity =
            values.gwp_levelling_min_quantity;
          payload.rules.maximum_qty_order_type =
            values.maximum_qty_order_type.value;

          if (!payload.rules.gwp_levelling_purchase_type) {
            Toast.show({
              text1: 'Please enter the Purchase Product by',
              type: 'error',
            });
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
          if (!payload.rules.gwp_levelling_type) {
            Toast.show({
              text1: 'Please enter the Minimum Requirements',
              type: 'error',
            });
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
          if (payload.rules.gwp_levelling_type == 'quantity') {
            if (!payload.rules.gwp_levelling_min_quantity) {
              Toast.show({
                text1: 'Please enter the Minimum Quantity',
                type: 'error',
              });
              dispatch(showPopup({ name: 'isLoading', value: false }));
              return;
            }
          } else {
            if (!payload.rules.gwp_levelling_min_amount) {
              Toast.show({
                text1: 'Please enter the Minimum Amount',
                type: 'error',
              });
              dispatch(showPopup({ name: 'isLoading', value: false }));
              return;
            }
          }

          for (const bundle of levelProductGwp.purchaseProduct) {
            if (!bundle.items?.length) {
              Toast.show({
                text1: 'Please enter the product which is to be purchased',
                type: 'error',
              });
              dispatch(showPopup({ name: 'isLoading', value: false }));
              return;
            }
            for (const prod of bundle.items) {
              if (
                (!prod.quantity || prod.quantity == '0') &&
                payload.rules.gwp_levelling_type == 'quantity'
              ) {
                Toast.show({
                  text1:
                    'Please enter quantity of the product which is to be purchased',
                  type: 'error',
                });
                dispatch(showPopup({ name: 'isLoading', value: false }));
                return;
              }
            }
          }

          for (const bundle of levelProductGwp.freeProduct) {
            if (!bundle.items?.length) {
              Toast.show({
                text1: 'Please enter the free product',
                type: 'error',
              });
              dispatch(showPopup({ name: 'isLoading', value: false }));
              return;
            }
            for (const prod of bundle.items) {
              if (!prod.quantity || prod.quantity == '0') {
                Toast.show({
                  text1: 'Please enter quantity of the free product',
                  type: 'error',
                });
                dispatch(showPopup({ name: 'isLoading', value: false }));
                return;
              }
              if (
                prod.tax_value == '' ||
                prod.tax_value == null ||
                prod.tax_value == undefined
              ) {
                Toast.show({
                  text1: 'Please enter tax of the free product',
                  type: 'error',
                });
                dispatch(showPopup({ name: 'isLoading', value: false }));
                return;
              }
            }
          }
        } else {
          payload.rules.is_gwp_levelling = false;
          if (!selectedBrand?.length && !selectedProduct?.length) {
            Toast.show({
              text1: 'Please enter the product which is to be purchased',
              type: 'error',
            });
            dispatch(showPopup({ name: 'isLoading', value: false }));
            return;
          }
        }
      }
      if (
        selectedBrand?.length ||
        selectedCategory?.length ||
        selectedProduct?.length
      ) {
        if (payload.promotion_model == 'buy_x_get_x_and_buy_x_get_y') {
          const finalProduct = selectedProduct.map((p) => {
            p.quantity = values.qty_purchased_product
              ? Number(values.qty_purchased_product)
              : 1;
            return p;
          });
          payload.rules.products = finalProduct?.length ? finalProduct : [];
          payload.rules.brands = selectedBrand?.length
            ? selectedBrand.map((item) => {
                return {
                  id: item.id,
                  name: item.name,
                  minimum_purchase: Number(values.minimum_purchase),
                };
              })
            : [];
        } else {
          payload.rules.brands = selectedBrand?.length
            ? selectedBrand.map((item) => {
                return {
                  id: item.id,
                  name: item.name,
                  minimum_purchase: 1000,
                };
              })
            : [];
          payload.rules.categories = selectedCategory?.length
            ? selectedCategory.map((item) => {
                return { id: item.id, name: item.name };
              })
            : [];
          payload.rules.products = selectedProduct?.length
            ? selectedProduct
            : [];
        }
      }

      if (payload.rules.is_gwp_levelling) {
        if (payload.rules.gwp_levelling_purchase_type == 'product') {
          const gwpBundle = levelProductGwp.purchaseProduct.map((b) => {
            return {
              bundle_id: b.bundle_id || generateUUIDv4(),
              level: b.level,
              products: b.items,
            };
          });
          payload.rules.gwp_levelling_products = gwpBundle;
        } else {
          const gwpBundle = levelProductGwp.purchaseProduct.map((b) => {
            return {
              bundle_id: b.bundle_id || generateUUIDv4(),
              level: b.level,
              brands: b.items,
            };
          });
          payload.rules.gwp_levelling_brands = gwpBundle;
        }
        payload.discount_info.gwp_levelling_free_products =
          levelProductGwp.freeProduct.map((b) => {
            return {
              bundle_id: b.bundle_id || generateUUIDv4(),
              level: b.level,
              products: b.items,
            };
          });
      }

      payload.rules.is_applicable_for_all_sales_team = !values
        ?.selected_sales_team?.length
        ? true
        : false;
      payload.rules.is_applicable_for_all_customers =
        !selectedCustomer?.length &&
        !(selectedMarketType && Object.keys(selectedMarketType).length) &&
        !values?.selected_cluster?.length &&
        !selectedCustomerType?.length
          ? true
          : false;
      if (payload.promotion_model == 'buy_x_get_x_and_buy_x_get_y') {
        payload.rules.is_applicable_for_all_products = !selectedProduct?.length
          ? true
          : false;
      } else {
        payload.rules.is_applicable_for_all_products =
          !selectedBrand?.length &&
          !selectedCategory?.length &&
          !selectedProduct?.length
            ? true
            : false;
      }
    }
    try {
      if (isEdit) {
        let updateData = null;
        if (payload.current_status == 'need_approval') {
          const status = payload.current_status;
          delete payload.current_status;
          updateData = await MsOrder.updatePromotionRulesStatus(
            detailData._id,
            status,
            payload,
          );
        } else {
          updateData = await MsOrder.updatePromotionRules(
            detailData._id,
            payload,
          );
        }

        if (updateData && updateData.data && updateData.data.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          dispatch(
            showAlert({
              show: true,
              title: 'Edit Promotion Rules Submitted',
              description:
                'Promotion rule changes submitted, you’ll be notified once it’s approved.',
              isConfirm: false,
              onCallback: () => {
                if (isEdit) {
                  setTimeout(() => {
                    props.navigation.reset({
                      index: 0,
                      routes: [
                        {
                          name: 'PromotionRulesDetailScreen',
                          params: {
                            ...props.route.params,
                            reload: true,
                          },
                        },
                      ],
                    });
                  }, 500);
                } else {
                  props.navigation.navigate('PromotionRulesScreen', {
                    titleScreen: detailData.reference_code,
                    name: detailData.name,
                    id: detailData._id,
                  });
                }
              },
            }),
          );
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      } else {
        const createData = await MsOrder.createPromotionRules(payload);
        if (createData && createData.data && createData.data.data) {
          const result = createData.data.data;
          dispatch(showPopup({ name: 'isLoading', value: false }));
          dispatch(
            showAlert({
              show: true,
              title: 'Promotion Rules Submitted',
              description:
                'Promotion rule submitted, you’ll be notified once it’s approved.',
              isConfirm: false,
              onCallback: () => {
                if (result._id) {
                  setTimeout(() => {
                    props.navigation.reset({
                      index: 0,
                      routes: [
                        {
                          name: 'PromotionRulesDetailScreen',
                          params: {
                            titleScreen: result.reference_code,
                            name: result.name,
                            id: result._id,
                            reload: true,
                          },
                        },
                      ],
                    });
                  }, 500);
                } else {
                  props.navigation.reset({
                    index: 0,
                    routes: [{ name: 'PromotionRulesScreen' }],
                    params: {
                      reload: true,
                    },
                  });
                }
              },
            }),
          );
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1:
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          'A system error occurred',
        type: 'error',
      });
    }
  };

  const InfoForm = ({
    handleChange,
    setFieldValue,
    values,
    errors,
    touched,
  }) => {
    return (
      <Layout.FormWrapper style={styles.infoFormWrapper}>
        <View style={styles.infoFormLeft}>
          <Layout.FormGroup>
            <Input
              label="Rule Name"
              value={values.name ? values.name : ''}
              isRequired={true}
              hasError={errors.name && touched.name ? errors.name : null}
              onChangeText={handleChange('name')}
            />
          </Layout.FormGroup>
          <Layout.FormGroup>
            <Input
              multiline={true}
              numberOfLines={4}
              label="Rule Description"
              value={values.description ? values.description : ''}
              isRequired={true}
              hasError={
                errors.description && touched.description
                  ? errors.description
                  : null
              }
              onChangeText={handleChange('description')}
            />
          </Layout.FormGroup>
          <Layout.FormGroup>
            <SociollaText style={{ fontSize: 11, marginBottom: 5 }}>
              Periode
            </SociollaText>
            <View style={{ width: '100%', flexDirection: 'row' }}>
              <DatePicker
                label="From Date"
                name="from_date"
                style={{
                  marginRight: isWeb ? 10 : 0,
                  width: isWeb ? 'calc(50% - 5px)' : '50%',
                }}
                value={values.from_date}
                disablePastDates={true}
                hasError={
                  errors.from_date && touched.from_date
                    ? errors.from_date
                    : null
                }
                onChange={(value) => {
                  setFieldValue('to_date', addDays(new Date(value), 1));
                  setFieldValue('from_date', value);
                }}
              />
              <DatePicker
                label="To Date"
                name="to_date"
                style={{ width: isWeb ? 'calc(50% - 5px)' : '50%' }}
                value={values.to_date}
                disablePastDates={true}
                disableBeforeDate={values.from_date}
                hasError={
                  errors.to_date && touched.to_date ? errors.to_date : null
                }
                onChange={(value) => setFieldValue('to_date', value)}
              />
            </View>
          </Layout.FormGroup>
        </View>
        <View style={styles.infoFormRight}>
          <Layout.FormGroup>
            <SelectBox
              label="Status"
              options={[
                { name: 'Active', value: true },
                { name: 'Inactive', value: false },
              ]}
              value={values.is_active}
              trackBy="value"
              labelKey="name"
              isRequired={true}
              hasError={
                errors.is_active && touched.is_active ? errors.is_active : null
              }
              onChange={(value) => {
                setFieldValue('is_active', value);
                onChangeActive(value.value);
              }}
            />
          </Layout.FormGroup>
          <Layout.FormGroup>
            <SelectBox
              label="Promotion Type"
              options={promotionTypeList}
              value={values.promotion_type}
              trackBy="value"
              labelKey="name"
              isRequired={true}
              hasError={
                errors.promotion_type && touched.promotion_type
                  ? errors.promotion_type
                  : null
              }
              onChange={(value) => setFieldValue('promotion_type', value)}
            />
          </Layout.FormGroup>
          <Layout.FormGroup>
            <SelectBox
              label="Promotion Model"
              options={promotionModelList}
              value={values.promotion_model}
              trackBy="value"
              labelKey="name"
              isRequired={true}
              hasError={
                errors.promotion_model && touched.promotion_model
                  ? errors.promotion_model
                  : null
              }
              onChange={(value) => {
                // reset all rules and discount info after change promotion models
                setFieldValue('promotion_model', value);
                setFieldValue('sales_team', salesTeamTypes[0]);
                setFieldValue('customers', customerTypes[0]);
                setFieldValue('product', productTypes[0]);
                setFieldValue('deduction_percentage', '');
                setFieldValue('no_of_transactions', '');
                setFieldValue('maximum_applied_per_customer', '');
                setFieldValue('maximum_qty_order', '');
                setFieldValue('qty_purchased_product', '');
                setFieldValue('qty_free_product', '');
                setFieldValue('tax_free_product', '');
                setFieldValue('selected_sales_team', []);
                setFieldValue('selected_cluster', []);
                resetRules();
                setFieldValue('purchased_product', '');
                setFieldValue('free_product', '');
                setFieldValue('budget', '');
              }}
            />
          </Layout.FormGroup>
        </View>
      </Layout.FormWrapper>
    );
  };

  const QtyInput = ({ it, onChangeQty, editable }) => {
    const [localQty, setLocalQty] = useState(it.quantity || '');

    return (
      <Input
        value={localQty}
        onChangeText={(val) => setLocalQty(val)}
        onBlur={() => onChangeQty(it, localQty)}
        style={{ width: '90%', height: isWeb ? '100%' : 30 }}
        isNumeric={false}
        isTransparent={true}
        editable={editable}
      />
    );
  };

  const TaxInput = ({ it, onChangeTax, editable }) => {
    const [localTax, setLocalTax] = useState(it.tax_value || '');

    return (
      <Input
        value={localTax}
        onChangeText={(val) => setLocalTax(val)}
        onBlur={() => onChangeTax(it, localTax)}
        style={{ width: '90%', height: isWeb ? '100%' : 30 }}
        isNumeric={false}
        isTransparent={true}
        editable={editable}
      />
    );
  };

  const LevelProductTable = ({
    items,
    onChangeQty,
    onChangeTax,
    onDelete,
    isWeb,
    type,
    sectionType,
  }) => {
    const PRODUCT_COLS = {
      img: 0.6,
      brand: 1,
      name: 2.2,
      attr: 1,
      quantity: 0.5,
      tax: 0.5,
      action: 0.4,
    };
    const is_brand = type === 'brand';

    if (!items || items.length === 0) {
      return null;
    }

    return (
      <ScrollView
        style={{
          borderWidth: 1,
          borderColor: '#D9D9D9',
          borderRadius: 4,
          marginBottom: 30,
          maxHeight: 300,
        }}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}>
        <View
          style={{
            flexDirection: 'row',
            backgroundColor: '#233876',
            paddingVertical: 10,
            paddingHorizontal: 12,
          }}>
          {is_brand ? (
            <>
              <SociollaText
                type={isWeb ? 'medium' : 'regular'}
                style={{ flex: 2, color: 'white', fontSize: 13 }}>
                Brand Name
              </SociollaText>

              <SociollaText
                type={isWeb ? 'medium' : 'regular'}
                style={{
                  flex: 1,
                  color: 'white',
                  fontSize: 13,
                  textAlign: 'center',
                }}>
                Qty
              </SociollaText>

              <SociollaText
                type={isWeb ? 'medium' : 'regular'}
                style={{
                  flex: 0.5,
                  color: 'white',
                  fontSize: 13,
                  textAlign: 'right',
                }}></SociollaText>
            </>
          ) : (
            <>
              <View
                style={{ flex: PRODUCT_COLS.img, justifyContent: 'center' }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ color: 'white', fontSize: 13 }}>
                  Image
                </SociollaText>
              </View>

              <View
                style={{
                  flex: PRODUCT_COLS.brand,
                  paddingLeft: 12,
                  justifyContent: 'center',
                }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ color: 'white', fontSize: 13 }}>
                  Brand Name
                </SociollaText>
              </View>

              <View
                style={{
                  flex: PRODUCT_COLS.name,
                  paddingLeft: 12,
                  justifyContent: 'center',
                }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ color: 'white', fontSize: 13 }}>
                  Product Name
                </SociollaText>
              </View>

              <View
                style={{
                  flex: PRODUCT_COLS.attr,
                  paddingLeft: 12,
                  justifyContent: 'center',
                }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ color: 'white', fontSize: 13 }}>
                  Attribute
                </SociollaText>
              </View>

              <View
                style={{
                  flex: PRODUCT_COLS.quantity,
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingLeft: 12,
                }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ color: 'white', fontSize: 13 }}>
                  Qty
                </SociollaText>
              </View>

              <RenderIf condition={sectionType == 'freeProduct'}>
                <View
                  style={{
                    flex: PRODUCT_COLS.tax,
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingLeft: 12,
                  }}>
                  <SociollaText
                    type={isWeb ? 'medium' : 'regular'}
                    style={{ color: 'white', fontSize: 13 }}>
                    Tax
                  </SociollaText>
                </View>
              </RenderIf>

              <View
                style={{
                  flex: PRODUCT_COLS.action,
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                }}>
                {/* kosong (ikon delete di body) */}
                <SociollaText style={{ color: 'transparent' }}>.</SociollaText>
              </View>
            </>
          )}
        </View>

        {is_brand
          ? items.map((it, idx) => (
              <View
                key={idx}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingVertical: 12,
                  paddingHorizontal: 12,
                  backgroundColor: idx % 2 === 0 ? '#FAFAFA' : '#FFFFFF',
                }}>
                <SociollaText
                  type={isWeb ? 'medium' : 'regular'}
                  style={{ flex: 2, fontSize: 13, color: '#1A1A1A' }}
                  numberOfLines={1}>
                  {it.name}
                </SociollaText>

                <View
                  style={{
                    flex: 1,
                    alignItems: 'center',
                    backgroundColor: '#FFFFFF',
                  }}
                  key={`${it.id}-${idx}`}>
                  <QtyInput
                    it={it}
                    onChangeQty={onChangeQty}
                    editable={
                      sectionType == 'freeProduct'
                        ? true
                        : gwpLevelingData.minimum_requirement === 'quantity'
                    }
                  />
                </View>

                <TouchableOpacity
                  onPress={() => onDelete(it)}
                  style={{
                    flex: 0.5,
                    alignItems: 'flex-end',
                    justifyContent: 'center',
                  }}>
                  <Image
                    style={{ width: 16, height: 16, tintColor: '#8C8C8C' }}
                    width={16}
                    height={16}
                    svg={true}
                    source={require('@assets/img/icons/trash-grey.svg')}
                  />
                </TouchableOpacity>
              </View>
            ))
          : items.map((it, idx) => (
              <View
                key={it.id || idx}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingVertical: 12,
                  paddingHorizontal: 12,
                  backgroundColor: idx % 2 === 0 ? '#FAFAFA' : '#FFFFFF',
                }}>
                <View
                  style={{
                    flex: PRODUCT_COLS.img,
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}>
                  <Image
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      borderWidth: 1,
                      borderColor: '#E6E6E6',
                    }}
                    width={48}
                    height={48}
                    source={it.image}
                  />
                </View>

                {/* Brand Name */}
                <View style={{ flex: PRODUCT_COLS.brand, paddingLeft: 12 }}>
                  <SociollaText
                    type={isWeb ? 'medium' : 'regular'}
                    style={{ fontSize: 13, color: '#1A1A1A' }}
                    numberOfLines={1}>
                    {it.brand?.name || '-'}
                  </SociollaText>
                </View>

                {/* Product Name (SKU + Name) */}
                <View style={{ flex: PRODUCT_COLS.name, paddingLeft: 12 }}>
                  <SociollaText
                    type={isWeb ? 'medium' : 'regular'}
                    style={{ fontSize: 13, color: '#1A1A1A' }}
                    numberOfLines={1}>
                    {/* {`[${it.sku}] ${it.name}`} */}
                    {it.name}
                  </SociollaText>
                </View>

                {/* Attribute */}
                <View style={{ flex: PRODUCT_COLS.attr, paddingLeft: 12 }}>
                  <SociollaText
                    type={isWeb ? 'medium' : 'regular'}
                    style={{ fontSize: 13, color: '#1A1A1A' }}
                    numberOfLines={1}>
                    {it.variant || 'Non Specify'}
                  </SociollaText>
                </View>

                <View
                  style={{
                    flex: PRODUCT_COLS.tax,
                    alignItems: 'center',
                    backgroundColor: '#FFFFFF',
                    marginLeft: 12,
                  }}
                  key={it.id}>
                  <QtyInput
                    it={it}
                    onChangeQty={onChangeQty}
                    editable={
                      sectionType == 'freeProduct'
                        ? true
                        : gwpLevelingData.minimum_requirement === 'quantity'
                    }
                  />
                </View>

                <RenderIf condition={sectionType == 'freeProduct'}>
                  <View
                    style={{
                      flex: PRODUCT_COLS.quantity,
                      alignItems: 'center',
                      backgroundColor: '#FFFFFF',
                      marginLeft: 12,
                    }}
                    key={it.id}>
                    <TaxInput it={it} onChangeTax={onChangeTax} />
                  </View>
                </RenderIf>

                {/* Action */}
                <View
                  style={{ flex: PRODUCT_COLS.action, alignItems: 'center' }}>
                  <TouchableOpacity
                    onPress={() => onDelete(it)}
                    hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
                    <Image
                      style={{ width: 16, height: 16, tintColor: '#8C8C8C' }}
                      width={16}
                      height={16}
                      svg
                      source={require('@assets/img/icons/trash-grey.svg')}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            ))}
      </ScrollView>
    );
  };

  const renderLevel = ({
    type,
    sectionType,
    lvl,
    gwpLevelingData,
    isWeb,
    listProduct,
    listBrand,
    setLevelItems,
    setLevelUi,
    onSearchRules,
    setListProduct,
    setListBrand,
    index,
  }) => {
    return (
      <View
        key={`${sectionType}-${lvl.level}`}
        style={{
          marginBottom: isWeb ? 16 : 8,
          borderBottomColor: '#BDC1C9',
          borderBottomWidth: 1,
        }}>
        <View
          style={{
            marginTop: 22,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'flex-start',
            paddingBottom: 30,
          }}>
          <View
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              ...(isWeb ? {} : { width: '100%' }),
            }}>
            {isWeb ? (
              <SociollaText
                type={isWeb ? 'medium' : 'regular'}
                style={{ color: '#171D29', fontSize: 12, marginTop: 11 }}>
                Level {lvl.level}
              </SociollaText>
            ) : (
              <View
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  width: '100%',
                }}>
                <SociollaText
                  type={'medium'}
                  style={{ color: '#171D29', fontSize: 12 }}>
                  Level {lvl.level}
                </SociollaText>
                {index !== 0 ? (
                  <TouchableOpacity
                    onPress={() => deleteLevel(sectionType, lvl.level)}>
                    <SociollaText
                      type={isWeb ? 'medium' : 'bold'}
                      style={{ fontSize: 12, color: Colors.blue0 }}>
                      Delete
                    </SociollaText>
                  </TouchableOpacity>
                ) : (
                  false
                )}
              </View>
            )}
          </View>
          {isWeb ? (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: 400,
                gap: 10,
              }}>
              <SelectFormRules
                type={type}
                placeholder={`Type ${type} name`}
                value={lvl.items}
                lists={
                  type === 'product' || type === 'free_product'
                    ? listProduct
                    : listBrand
                }
                withoutResult={false}
                noMounted={true}
                selectedBox={lvl.items}
                setSelectedBox={(val) =>
                  setLevelItems(sectionType, lvl.level, val)
                }
                showList={{
                  [type]: lvl.ui?.showList || false,
                }}
                searchKeyword={{
                  [type]: lvl.ui?.searchKeyword || '',
                }}
                isLoading={{
                  [type]: lvl.ui?.isLoading || false,
                }}
                isLoadingMore={{
                  [type]: lvl.ui?.isLoadingMore || false,
                }}
                isEmpty={{
                  [type]: lvl.ui?.isEmpty || false,
                }}
                setShowList={(obj) => {
                  setLevelUi(sectionType, lvl.level, 'showList', obj[type]);
                }}
                setSearchKeyword={(obj) => {
                  setLevelUi(
                    sectionType,
                    lvl.level,
                    'searchKeyword',
                    obj[type],
                  );
                }}
                setIsLoading={(obj) => {
                  setLevelUi(sectionType, lvl.level, 'isLoading', obj[type]);
                }}
                setIsLoadingMore={(obj) => {
                  setLevelUi(
                    sectionType,
                    lvl.level,
                    'isLoadingMore',
                    obj[type],
                  );
                }}
                onChange={(val) => setLevelItems(sectionType, lvl.level, val)}
                onSearch={({ type, value }) => {
                  setLevelUi(sectionType, lvl.level, 'showList', true);
                  setLevelUi(sectionType, lvl.level, 'searchKeyword', value);
                  setLevelUi(sectionType, lvl.level, 'skip', 0);

                  onSearchRules(type, value, true).then((res) => {
                    if (type === 'product' || type === 'free_product') {
                      setListProduct(res);
                    } else if (type === 'brand') {
                      setListBrand(res);
                    }
                  });
                }}
                onLoadMore={(type) => {
                  const nextSkip = (lvl.ui?.skip || 0) + 10;

                  setLevelUi(sectionType, lvl.level, 'isLoadingMore', true);
                  setLevelUi(sectionType, lvl.level, 'skip', nextSkip);

                  onSearchRules(
                    type,
                    lvl.ui?.searchKeyword || '',
                    true,
                    nextSkip,
                  ).then((res) => {
                    if (type === 'product') {
                      setListProduct((prev) => [...prev, ...res]);
                    } else if (type === 'brand') {
                      setListBrand((prev) => [...prev, ...res]);
                    }

                    setLevelUi(sectionType, lvl.level, 'isLoadingMore', false);
                  });
                }}
              />
              {index !== 0 ? (
                <Button
                  type="outline-primary"
                  rounded
                  buttonStyle={{ width: 60 }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{
                        fontSize: 10,
                        letterSpacing: 0.5,
                      }}>
                      Delete
                    </SociollaText>
                  }
                  onPress={() => deleteLevel(sectionType, lvl.level)}
                />
              ) : (
                false
              )}
            </View>
          ) : null}
        </View>
        {isWeb ? (
          <LevelProductTable
            sectionType={sectionType}
            type={type}
            items={lvl.items}
            isWeb={isWeb}
            onChangeQty={(item, quantity) => {
              const updated = lvl.items.map((p) =>
                p.id === item.id ? { ...p, quantity } : p,
              );
              setLevelItems(sectionType, lvl.level, updated);
            }}
            onChangeTax={(item, tax) => {
              const updated = lvl.items.map((p) =>
                p.id === item.id ? { ...p, tax_value: tax } : p,
              );
              setLevelItems(sectionType, lvl.level, updated);
            }}
            onDelete={(item) => {
              const filtered = lvl.items.filter((p) => p.id !== item.id);
              setLevelItems(sectionType, lvl.level, filtered);
            }}
          />
        ) : (
          <View style={{ display: 'flex' }}>
            {lvl.items.map((it, idx) => {
              const handleChangeQty = (val) => {
                const updated = lvl.items.map((p) =>
                  p.id === it.id ? { ...p, quantity: val } : p,
                );
                setLevelItems(sectionType, lvl.level, updated);
              };

              const handleChangeTax = (val) => {
                const updated = lvl.items.map((p) =>
                  p.id === it.id ? { ...p, tax_value: val } : p,
                );
                setLevelItems(sectionType, lvl.level, updated);
              };

              const handleDelete = () => {
                const filtered = lvl.items.filter((p) => p.id !== it.id);
                setLevelItems(sectionType, lvl.level, filtered);
              };

              return (
                <View
                  key={it.id || idx}
                  style={{
                    marginBottom: 16,
                    borderBottomWidth: 1,
                    borderBottomColor: '#E6E6E6',
                    paddingBottom: 12,
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                  }}>
                  {type === 'brand' ? (
                    <View
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}>
                      <SociollaText
                        type="regular"
                        style={{
                          fontSize: 12,
                          color: '#1A1A1A',
                          marginBottom: 10,
                        }}
                        numberOfLines={1}>
                        {it.name}
                      </SociollaText>

                      {/* Qty input */}
                      <View
                        style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <SociollaText
                          style={{
                            fontSize: 12,
                            color: '#595959',
                            marginRight: 8,
                          }}>
                          Qty:
                        </SociollaText>
                        <View
                          style={{
                            width: 160,
                          }}>
                          <QtyInput
                            it={it}
                            onChangeQty={(_, quantity) =>
                              handleChangeQty(quantity)
                            }
                            editable={
                              gwpLevelingData.minimum_requirement === 'quantity'
                            }
                          />
                        </View>
                      </View>
                    </View>
                  ) : (
                    <>
                      {/* Image + SKU */}
                      <View
                        style={{
                          flexDirection: 'row',
                          display: 'flex',
                          gap: 16,
                        }}>
                        <Image
                          style={{
                            width: 42,
                            height: 42,
                          }}
                          width={42}
                          height={42}
                          source={it.image}
                        />
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10,
                          }}>
                          <SociollaText
                            type="regular"
                            style={{ fontSize: 12, color: '#171D29' }}
                            numberOfLines={1}>
                            [{it.sku}]
                          </SociollaText>
                          {/* Brand + Name */}
                          <View
                            style={{
                              flexWrap: 'wrap',
                              width: isWeb ? '80%' : 200,
                            }}>
                            <SociollaText
                              type="regular"
                              style={{
                                fontSize: 11,
                                color: '#171D29',
                                marginBottom: 2,
                                flexShrink: 1,
                              }}
                              numberOfLines={2}>
                              {it.brand?.name} - {it.name}
                            </SociollaText>
                          </View>

                          {/* Variant */}
                          <SociollaText
                            style={{
                              fontSize: 11,
                              color: '#7D838F',
                              marginBottom: 4,
                            }}>
                            {it.variant || 'Non Specify'}
                          </SociollaText>
                          {/* Qty input */}
                          <View
                            style={{ flexDirection: 'row', display: 'flex' }}>
                            <SociollaText
                              style={{
                                fontSize: 11,
                                color: '#595959',
                                marginRight: 8,
                                alignContent: 'center',
                              }}>
                              Qty:
                            </SociollaText>
                            <View
                              style={{
                                width: 160,
                              }}>
                              <QtyInput
                                it={it}
                                onChangeQty={(_, quantity) =>
                                  handleChangeQty(quantity)
                                }
                                editable={
                                  gwpLevelingData.minimum_requirement ===
                                  'quantity'
                                }
                              />
                            </View>
                          </View>

                          {/* Tax input */}
                          <RenderIf condition={sectionType == 'freeProduct'}>
                            <View
                              style={{ flexDirection: 'row', display: 'flex' }}>
                              <SociollaText
                                style={{
                                  fontSize: 11,
                                  color: '#595959',
                                  marginRight: 8,
                                  alignContent: 'center',
                                }}>
                                Tax:
                              </SociollaText>
                              <View
                                style={{
                                  width: 160,
                                }}>
                                <TaxInput
                                  it={it}
                                  onChangeTax={(_, tax) => handleChangeTax(tax)}
                                />
                              </View>
                            </View>
                          </RenderIf>
                        </View>
                      </View>
                    </>
                  )}

                  {/* Delete */}
                  <TouchableOpacity
                    onPress={handleDelete}
                    style={{
                      right: 0,
                      top: 0,
                      marginTop: 3,
                    }}>
                    <Image
                      style={{ width: 12, height: 12, tintColor: '#8C8C8C' }}
                      width={12}
                      height={12}
                      source={require('@assets/img/icons/trash-grey.svg')}
                    />
                  </TouchableOpacity>
                </View>
              );
            })}
          </View>
        )}
        {!isWeb ? (
          <View
            style={{
              marginBottom: 15,
            }}>
            <SelectProductV2
              isButton={true}
              searchBrand={type === 'brand'}
              label={`Add ${
                purchaseProductByOptions.find((option) => option.value === type)
                  ?.label || 'Product'
              }`}
              placeholder={`Type ${type} name`}
              value={lvl.items && lvl.items.length > 0 ? lvl.items[0] : {}}
              showVariant={false}
              onChange={(value) => {
                const pr = {
                  id: value.id,
                  name: value.name,
                  brand: {
                    id: value.brand?.id,
                    name: value.brand?.name,
                  },
                  combination_id:
                    value.combination?._id || value.combination_id,
                  variant: value.combination?.attributes
                    ? getAttibutes(value.combination.attributes)
                    : value.variant || '-',
                  sku: value.combination?.reference || value.sku || '-',
                  image:
                    value.combination?.images?.[0]?.url || value.image || '',
                  quantity: 0,
                };

                const updated = [
                  ...(lvl.items || []).filter(
                    (p) =>
                      !(
                        p.id === pr.id &&
                        (p.combination_id === pr.combination_id ||
                          !pr.combination_id)
                      ),
                  ),
                  pr,
                ];

                setLevelItems(sectionType, lvl.level, updated);
              }}
            />
          </View>
        ) : (
          false
        )}
      </View>
    );
  };

  const renderAddButton = (sectionType, addDefaultLevelGwp) => (
    <Button
      rounded
      buttonStyle={{ width: 120 }}
      title={
        <SociollaText
          type="bold"
          style={{
            fontSize: 12,
            letterSpacing: 0.5,
            color: Colors.white,
          }}>
          Add other level
        </SociollaText>
      }
      onPress={() => addDefaultLevelGwp(sectionType)}
    />
  );

  const renderSection = ({
    sectionType,
    levels,
    gwpLevelingData,
    isWeb,
    listProduct,
    listBrand,
    setLevelItems,
    setLevelUi,
    onSearchRules,
    setListProduct,
    setListBrand,
    addDefaultLevelGwp,
    type,
  }) => (
    <>
      {levels.map((lvl, index) =>
        renderLevel({
          sectionType,
          lvl,
          gwpLevelingData,
          isWeb,
          listProduct,
          listBrand,
          setLevelItems,
          setLevelUi,
          onSearchRules,
          setListProduct,
          setListBrand,
          index,
          type,
        }),
      )}
      {renderAddButton(sectionType, addDefaultLevelGwp)}
    </>
  );

  const RegularAndCbd = ({
    values,
    setFieldValue,
    errors,
    touched,
    handleChange,
  }) => {
    if (
      !['regular_discount', 'cash_before_delivery'].includes(
        values.promotion_model?.value,
      )
    ) {
      return false;
    }

    return (
      <>
        {values.promotion_model?.value == 'regular_discount' ? (
          <Layout.FormGroup>
            <CustomerClusterSearch
              value={values.cluster}
              isRequired={true}
              hasError={
                errors.cluster && touched.cluster ? errors.cluster : null
              }
              onChange={(value) => setFieldValue('cluster', value)}
            />
          </Layout.FormGroup>
        ) : (
          false
        )}
        <Layout.FormGroup>
          <View
            style={{
              maxWidth: 215,
              paddingRight: 20,
              position: 'relative',
            }}>
            <Input
              label="Percent Discount"
              value={
                values.deduction_percentage ? values.deduction_percentage : ''
              }
              isRequired={true}
              keyboardType="numeric"
              isDecimal={true}
              hasError={
                errors.deduction_percentage && touched.deduction_percentage
                  ? errors.deduction_percentage
                  : null
              }
              onChangeText={handleChange('deduction_percentage')}
            />
            <SociollaText
              style={{
                position: 'absolute',
                right: 0,
                top: 40,
              }}>
              %
            </SociollaText>
          </View>
        </Layout.FormGroup>
      </>
    );
  };

  const ExtraAndBuyGet = ({
    values,
    setFieldValue,
    errors,
    touched,
    handleChange,
    setFieldTouched,
  }) => {
    if (
      !['extra_discount', 'buy_x_get_x_and_buy_x_get_y'].includes(
        values.promotion_model?.value,
      )
    ) {
      return false;
    }

    return (
      <>
        <View style={styles.sectionContainer}>
          {/* Start Sales Team Rules */}
          {isWeb ? (
            // Sales Team Picker Desktop
            <Layout.FormGroup>
              <RadioButton
                label="Sales Team"
                orientation="vertical"
                value={values.sales_team}
                data={salesTeamTypes}
                onChange={(value) => {
                  setFieldValue('selected_sales_team', []);
                  setFieldValue(
                    'sales_team',
                    salesTeamTypes.find((a) => a.value == value),
                  );
                }}
              />
              {
                // Specific Sales Team
                values.sales_team?.value == 'specific_sales_team' ? (
                  <View style={styles.chooseRules}>
                    <SalesTeamSearch
                      hideLabel
                      multiple={true}
                      value={values.selected_sales_team}
                      onChange={(value) => {
                        setFieldValue('selected_sales_team', value);
                      }}
                      selectContainer={{ width: '100%' }}
                    />
                  </View>
                ) : (
                  false
                )
              }
            </Layout.FormGroup>
          ) : (
            // Sales Team Picker Mobile
            <SelectFormRulesMobile
              type="sales_team"
              data={values.selected_sales_team}
              labelValue={values.sales_team?.label}
              typeValue={values.sales_team?.value}
              stepModal={stepModal}
              setStepModal={(val) => setStepModal(val)}
              setShowRules={(val) => setShowRules(val)}
              setRulesType={(val) => setRulesType(val)}
            />
          )}
          {/* End Sales Team Rules */}
          {/* Start Customer Rules */}
          {isWeb ? (
            // Customer Picker Desktop
            <Layout.FormGroup>
              <RadioButton
                label="Customer"
                orientation="vertical"
                value={values.customers}
                data={customerTypes}
                onChange={(value) => {
                  setSelectedMarketType({});
                  setSelectedBusinessType([]);
                  setSelectedCustomer([]);
                  setSelectedCustomerType([]);
                  setFieldValue(
                    'customers',
                    customerTypes.find((a) => a.value == value),
                  );
                  setFieldValue('selected_cluster', []);
                }}
              />
              {
                // Specific Market Type & Business
                values.customers?.value == 'specific_market_business_type' &&
                markettypes?.length ? (
                  <View style={{ width: '100%' }}>
                    {/* Start Market Type Picker */}
                    <View style={styles.chooseRules}>
                      <SociollaText
                        type="medium"
                        style={styles.chooseRulesText}>
                        Market Type
                      </SociollaText>
                      <RadioButton
                        value={selectedMarketType}
                        isWrap={true}
                        maxWidth={600}
                        data={markettypes.map((item) => {
                          return {
                            label: item.code,
                            value: item.code,
                          };
                        })}
                        onChange={(value) => {
                          setBusinessTypeList([]);
                          setSelectedBusinessType([]);
                          const marketTypeResult = markettypes
                            .map((item) => {
                              return {
                                id: item._id,
                                code: item.code,
                                label: item.code,
                                value: item.code,
                                business_type: item.business_type,
                              };
                            })
                            .find((a) => a.value == value);
                          if (marketTypeResult) {
                            setSelectedMarketType(
                              convertSelectedMarketType(marketTypeResult),
                            );
                            if (marketTypeResult?.business_type?.length) {
                              setBusinessTypeList(
                                marketTypeResult.business_type
                                  .filter((bt) => bt.is_active)
                                  .map((item) => {
                                    return convertBusinessType(item);
                                  }),
                              );
                            }
                          }
                        }}
                      />
                    </View>
                    {/* End Market Type Picker */}
                    {/* Start Business Type Picker */}
                    <View
                      style={[
                        styles.chooseRules,
                        {
                          flexDirection: 'column',
                          flexWrap: 'nowrap',
                        },
                      ]}>
                      <SociollaText
                        type="medium"
                        style={styles.chooseRulesText}>
                        Business Type
                      </SociollaText>
                      <View style={[styles.chooseRules, { paddingLeft: 0 }]}>
                        {businessTypeList.map((item, idx) => (
                          <View
                            style={{
                              width: '33.33333%',
                              padding: 5,
                            }}
                            key={idx}>
                            <CheckBox
                              value={item.code}
                              checked={
                                selectedBusinessType.findIndex(
                                  (a) => a.code == item.code,
                                ) > -1
                              }
                              onChange={(val) => {
                                const oldVal = JSON.parse(
                                  JSON.stringify(selectedBusinessType),
                                );
                                const index = oldVal.findIndex(
                                  (a) => a.code == val,
                                );
                                if (index > -1) {
                                  oldVal.splice(index, 1);
                                  setSelectedBusinessType(oldVal);
                                } else {
                                  const res = businessTypeList.find(
                                    (a) => a.code == val,
                                  );
                                  oldVal.push(res);
                                  setSelectedBusinessType(oldVal);
                                }
                              }}>
                              <SociollaText>{item.code}</SociollaText>
                            </CheckBox>
                          </View>
                        ))}
                      </View>
                    </View>
                    {/* End Business Type Picker */}
                  </View>
                ) : (
                  false
                )
              }
              {
                // Specific Customer
                values.customers?.value == 'specific_customer' ? (
                  <View style={{ width: '100%' }}>
                    <View style={styles.chooseRules}>
                      <SociollaText
                        type="medium"
                        style={styles.chooseRulesText}>
                        Select Customer or Upload CSV
                      </SociollaText>
                      <View
                        style={{
                          width: '100%',
                          flexDirection: 'row',
                        }}>
                        <SelectFormRules
                          type="customer"
                          placeholder="Type customer's name"
                          value={selectedCustomer}
                          onChange={(val) => setSelectedCustomer(val)}
                          showList={showList}
                          setShowList={(val) => setShowList(val)}
                          searchKeyword={searchKeyword}
                          isLoading={isLoading}
                          isLoadingMore={isLoadingMore}
                          isEmpty={isEmpty}
                          lists={listCustomer}
                          selectedBox={selectedBoxCustomer}
                          setSelectedBox={(val) => setSelectedBoxCustomer(val)}
                          onSearch={({ type, value }) => {
                            setShowList({
                              ...showList,
                              [type]: true,
                            });
                            setSearchType(type);
                            setSearchKeyword({
                              ...searchKeyword,
                              [type]: value,
                            });
                            setSkip({
                              ...skip,
                              [type]: 0,
                            });
                            onSearchRules(type, value, false, 0, values);
                          }}
                          onLoadMore={(type) => {
                            setRulesType(type);
                            setSkip({
                              ...skip,
                              [type]: skip[type] + 10,
                            });
                            setIsLoadingMore({
                              ...isLoadingMore,
                              [type]: true,
                            });
                          }}
                        />
                        <ButtonUploadCSV
                          type="customer"
                          onCallback={(val) => {
                            const newValue = selectedCustomer.concat(val);
                            setSelectedCustomer(newValue);
                            setSelectedBoxCustomer(newValue);
                          }}
                        />
                      </View>
                    </View>
                  </View>
                ) : (
                  false
                )
              }
              {
                // Spesific Cluster
                values.customers?.value == 'specific_cluster' ? (
                  <View style={styles.chooseRules}>
                    <CustomerClusterSearch
                      hideLabel
                      value={values.selected_cluster}
                      onChange={(value) =>
                        setFieldValue('selected_cluster', value)
                      }
                      isRequired
                      multiple
                      selectContainer={{ width: '100%' }}
                    />
                  </View>
                ) : (
                  false
                )
              }
              {values.customers?.value === 'specific_customer_type' &&
              customerSpecificType?.length > 0 ? (
                <View style={styles.chooseRules}>
                  {customerSpecificType.map((item, idx) => (
                    <View
                      style={{
                        width: '33.33333%',
                        padding: 5,
                      }}
                      key={idx}>
                      <CheckBox
                        value={item.value._id}
                        checked={
                          selectedCustomerType.findIndex(
                            (a) => a.value._id === item.value._id,
                          ) > -1
                        }
                        onChange={(val) => {
                          const oldVal = JSON.parse(
                            JSON.stringify(selectedCustomerType),
                          );
                          const index = oldVal.findIndex(
                            (a) => a.value._id === val,
                          );
                          if (index > -1) {
                            oldVal.splice(index, 1);
                            setSelectedCustomerType(oldVal);
                          } else {
                            const res = customerSpecificType.find(
                              (a) => a.value._id === val,
                            );
                            if (res) {
                              oldVal.push(res);
                              setSelectedCustomerType(oldVal);
                            }
                          }
                        }}>
                        <SociollaText>{item.label}</SociollaText>
                      </CheckBox>
                    </View>
                  ))}
                </View>
              ) : (
                false
              )}
            </Layout.FormGroup>
          ) : (
            // Customer Picker Mobile
            <SelectFormRulesMobile
              type="customer"
              data={
                values.customers?.value == 'specific_customer'
                  ? selectedCustomer
                  : values.customers?.value == 'specific_cluster'
                  ? values?.selected_cluster
                  : selectedBusinessType?.length
                  ? selectedBusinessType
                  : []
              }
              labelValue={
                ['specific_customer', 'all'].includes(values.customers?.value)
                  ? values.customers?.label
                  : values.customers?.value == 'specific_cluster'
                  ? values.customers?.label
                  : selectedMarketType && Object.keys(selectedMarketType).length
                  ? selectedMarketType.code
                  : ''
              }
              typeValue={values.customers?.value}
              stepModal={stepModal}
              setStepModal={(val) => setStepModal(val)}
              setShowRules={(val) => setShowRules(val)}
              setRulesType={(val) => setRulesType(val)}
              setSelected={({ type, value }) => {
                if (type == 'specific_customer') {
                  setBusinessTypeList([]);
                  setSelectedBusinessType([]);
                  setSelectedCustomer(value);
                } else {
                  setSelectedCustomer([]);
                  setSelectedBusinessType(value);
                }
              }}
            />
          )}
          {/* End Customer Rules */}
          {/* Start Customer Rules */}
          {values.promotion_model?.value != 'buy_x_get_x_and_buy_x_get_y' ? (
            <>
              {/* Start Brand, Category and Product Rules */}
              {isWeb ? (
                // Brand, Category and Product Picker Desktop
                <Layout.FormGroup>
                  <RadioButton
                    label="Product"
                    orientation="vertical"
                    value={values.product}
                    data={productTypes}
                    onChange={(value) => {
                      setSelectedBrand([]);
                      setSelectedCategory([]);
                      setSelectedProduct([]);
                      setFieldValue(
                        'product',
                        productTypes.find((a) => a.value == value),
                      );
                    }}
                  />
                  {
                    // Specific Brand Picker
                    values.product?.value == 'specific_brand' ? (
                      <View style={{ width: '100%' }}>
                        <View style={styles.chooseRules}>
                          <SociollaText
                            type="medium"
                            style={styles.chooseRulesText}>
                            Select Brand
                          </SociollaText>
                          <SelectFormRules
                            type="brand"
                            placeholder="Type brand name"
                            value={selectedBrand}
                            onChange={(val) => setSelectedBrand(val)}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listBrand}
                            selectedBox={selectedBoxBrand}
                            setSelectedBox={(val) => setSelectedBoxBrand(val)}
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                        </View>
                      </View>
                    ) : (
                      false
                    )
                  }
                  {
                    // Specific Category Picker
                    values.product?.value == 'specific_categories' ? (
                      <View style={{ width: '100%' }}>
                        <View style={styles.chooseRules}>
                          <SociollaText
                            type="medium"
                            style={styles.chooseRulesText}>
                            Select Category
                          </SociollaText>
                          <SelectFormRules
                            type="category"
                            placeholder="Type category name"
                            value={selectedCategory}
                            onChange={(val) => setSelectedCategory(val)}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listCategory}
                            selectedBox={selectedBoxCategory}
                            setSelectedBox={(val) =>
                              setSelectedBoxCategory(val)
                            }
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                        </View>
                      </View>
                    ) : (
                      false
                    )
                  }
                  {
                    // Specific Product Picker
                    values.product?.value == 'specific_product' ? (
                      <View style={{ width: '100%' }}>
                        <View style={styles.chooseRules}>
                          <SociollaText
                            type="medium"
                            style={styles.chooseRulesText}>
                            Select Product or Upload CSV
                          </SociollaText>
                          <View
                            style={{
                              width: '100%',
                              flexDirection: 'row',
                            }}>
                            <SelectFormRules
                              type="product"
                              placeholder="Type product's name"
                              value={selectedProduct}
                              onChange={(val) => setSelectedProduct(val)}
                              showList={showList}
                              searchKeyword={searchKeyword}
                              isLoading={isLoading}
                              isLoadingMore={isLoadingMore}
                              isEmpty={isEmpty}
                              lists={listProduct}
                              selectedBox={selectedBoxProduct}
                              setSelectedBox={(val) =>
                                setSelectedBoxProduct(val)
                              }
                              setShowList={(val) => setShowList(val)}
                              setSearchType={(val) => setSearchType(val)}
                              setSearchKeyword={(val) => setSearchKeyword(val)}
                              setSkip={(val) => setSkip(val)}
                              setRulesType={(val) => setRulesType(val)}
                              setIsLoadingMore={(val) => setIsLoadingMore(val)}
                              onSearch={({ type, value }) => {
                                setShowList({
                                  ...showList,
                                  [type]: true,
                                });
                                setSearchType(type);
                                setSearchKeyword({
                                  ...searchKeyword,
                                  [type]: value,
                                });
                                setSkip({
                                  ...skip,
                                  [type]: 0,
                                });
                                onSearchRules(type, value);
                              }}
                              onLoadMore={(type) => {
                                setRulesType(type);
                                setSkip({
                                  ...skip,
                                  [type]: skip[type] + 10,
                                });
                                setIsLoadingMore({
                                  ...isLoadingMore,
                                  [type]: true,
                                });
                              }}
                            />
                            <ButtonUploadCSV
                              type="product"
                              onCallback={(val) => {
                                const newValue = selectedProduct.concat(val);
                                setSelectedProduct(newValue);
                                setSelectedBoxProduct(newValue);
                              }}
                            />
                          </View>
                        </View>
                      </View>
                    ) : (
                      false
                    )
                  }
                </Layout.FormGroup>
              ) : (
                // Brand, Category and Product Picker Mobile
                <SelectFormRulesMobile
                  type="product"
                  data={
                    selectedBrand?.length
                      ? selectedBrand
                      : selectedCategory?.length
                      ? selectedCategory
                      : selectedProduct?.length
                      ? selectedProduct
                      : []
                  }
                  labelValue={values.product?.label}
                  typeValue={values.product?.value}
                  setStepModal={(val) => setStepModal(val)}
                  setShowRules={(val) => setShowRules(val)}
                  setRulesType={(val) => setRulesType(val)}
                  setSelected={({ type, value }) => {
                    if (type == 'specific_brand') {
                      setSelectedCategory([]);
                      setSelectedProduct([]);
                      setSelectedBrand(value);
                    } else if (type == 'specific_categories') {
                      setSelectedBrand([]);
                      setSelectedProduct([]);
                      setSelectedCategory(value);
                    } else if (type == 'specific_product') {
                      setSelectedBrand([]);
                      setSelectedCategory([]);
                      setSelectedProduct(value);
                    }
                  }}
                />
              )}
              {/* End Brand, Category and Product Rules */}

              {/* Start Percent Discount Input Extra Discount */}
              <>
                {isWeb ? (
                  <RadioButton
                    label="Percent Discount"
                    orientation="vertical"
                    value={values.percentage_type}
                    data={ExtradiscountTypes}
                    onChange={(value) => {
                      setSelectedBoxRange([]);
                      setselectRange([]);
                      setFieldValue(
                        'percentage_type',
                        ExtradiscountTypes.find((a) => a.value == value),
                      );
                    }}
                  />
                ) : (
                  <SelectBox
                    label="Percent Discount"
                    placeholder="Choose Percent Discount"
                    options={ExtradiscountTypes}
                    value={values.percentage_type}
                    trackBy="value"
                    labelKey="label"
                    isRequired={true}
                    hasError={
                      errors.percentage_type && touched.percentage_type
                        ? errors.percentage_type
                        : null
                    }
                    onChange={(value) => {
                      setSelectedBoxRange([]);
                      setselectRange([]);
                      setFieldValue(
                        'percentage_type',
                        ExtradiscountTypes.find((a) => a.value == value.value),
                      );
                    }}
                  />
                )}
              </>
              {
                // All
                values.percentage_type?.value == 'all' ? (
                  <View
                    style={{
                      width: '100%',
                      marginTop: 10,
                    }}>
                    <View style={styles.chooseRules}>
                      <Input
                        label="Percent Discount"
                        value={
                          values.deduction_percentage
                            ? values.deduction_percentage
                            : ''
                        }
                        isRequired={true}
                        keyboardType="numeric"
                        isDecimal={true}
                        onChangeText={handleChange('deduction_percentage')}
                        hasError={
                          errors.deduction_percentage &&
                          touched.deduction_percentage
                            ? errors.deduction_percentage
                            : null
                        }
                      />
                      <SociollaText
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: 30,
                        }}>
                        %
                      </SociollaText>
                    </View>
                  </View>
                ) : (
                  false
                )
              }

              {
                // Specific Order
                values.percentage_type?.value == 'specific_order' ? (
                  <View
                    style={{
                      width: '80%',
                      marginTop: 10,
                    }}>
                    <View style={styles.chooseRules}>
                      <Input
                        label="First Order"
                        value={
                          values.first_order_deduction_percentage
                            ? values.first_order_deduction_percentage
                            : ''
                        }
                        isRequired={true}
                        keyboardType="numeric"
                        isDecimal={true}
                        hasError={
                          errors.first_order_deduction_percentage &&
                          touched.first_order_deduction_percentage
                            ? errors.first_order_deduction_percentage
                            : null
                        }
                        onChangeText={handleChange(
                          'first_order_deduction_percentage',
                        )}
                      />
                      <SociollaText
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: 30,
                        }}>
                        %
                      </SociollaText>
                    </View>
                    <View style={styles.chooseRules}>
                      <Input
                        label="Next Order"
                        value={
                          values.next_order_deduction_percentage
                            ? values.next_order_deduction_percentage
                            : ''
                        }
                        isRequired={true}
                        keyboardType="numeric"
                        isDecimal={true}
                        hasError={
                          errors.next_order_deduction_percentage &&
                          touched.next_order_deduction_percentage
                            ? errors.next_order_deduction_percentage
                            : null
                        }
                        onChangeText={handleChange(
                          'next_order_deduction_percentage',
                        )}
                      />
                      <SociollaText
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: 30,
                        }}>
                        %
                      </SociollaText>
                    </View>
                  </View>
                ) : (
                  false
                )
              }

              {
                // Specific Quantity Order
                values.percentage_type?.value == 'specific_quantity_order' ? (
                  <View
                    style={{
                      width: '80%',
                      marginTop: 10,
                    }}>
                    <View style={styles.chooseRules}>
                      <SociollaText>
                        <TouchableOpacity onPress={() => onRangeSelect()}>
                          <SociollaText type="medium" style={styles.addRange}>
                            + Add Range
                          </SociollaText>
                        </TouchableOpacity>
                      </SociollaText>
                      <SelectRangeRules
                        onClose={() => onCloseRange()}
                        show={showAddRange}
                        value={selectRange}
                        onChange={(val) => setselectRange(val)}
                        showList={showList}
                        selectedBox={selectedBoxRange}
                        setSelectedBox={(val) => setSelectedBoxRange(val)}
                        setShowList={(val) => setShowList(val)}
                      />
                    </View>
                  </View>
                ) : (
                  false
                )
              }

              {
                // Specific Amount Order
                values.percentage_type?.value == 'specific_amount_order' ? (
                  <View
                    style={{
                      width: '80%',
                      marginTop: 10,
                    }}>
                    <View style={styles.chooseRules}>
                      <SociollaText>
                        <TouchableOpacity onPress={() => onRangeSelect()}>
                          <SociollaText type="medium" style={styles.addRange}>
                            + Add Range
                          </SociollaText>
                        </TouchableOpacity>
                      </SociollaText>
                      <SelectRangeRules
                        mode="amount"
                        onClose={() => onCloseRange()}
                        show={showAddRange}
                        value={selectRange}
                        onChange={(val) => setselectRange(val)}
                        showList={showList}
                        selectedBox={selectedBoxRange}
                        setSelectedBox={(val) => setSelectedBoxRange(val)}
                        setShowList={(val) => setShowList(val)}
                      />
                    </View>
                  </View>
                ) : (
                  false
                )
              }
              {/* End Percent Discount Input Extra Discount */}
            </>
          ) : (
            false
          )}

          {values.promotion_model?.value == 'buy_x_get_x_and_buy_x_get_y' ? (
            <Layout.FormGroup>
              <>
                {isWeb ? (
                  <RadioButton
                    label="Condition"
                    orientation="vertical"
                    value={values.condition_buy_x_get_x}
                    data={conditionBuyxgetx}
                    onChange={(value) => {
                      setFieldValue(
                        'condition_buy_x_get_x',
                        conditionBuyxgetx.find((a) => a.value == value),
                      );
                      setFieldValue('maximum_qty_order_type', null);
                      resetGwpLeveling();
                      //reset all data related Qty/Min Purchase
                      resetQtyMinPurchase();
                      setFieldValue('purchased_product', '');
                      setFieldValue('qty_purchased_product', '');
                      setFieldValue('free_product', '');
                      setFieldValue('qty_free_product', '');
                      setFieldValue('tax_free_product', '');
                      setFieldValue('purchased_brand', '');
                      setFieldValue('minimum_purchase', '');
                      if (value == 'gwp_leveling') {
                        setFieldValue('is_gwp_levelling', true);
                      } else {
                        setFieldValue('is_gwp_levelling', false);
                      }
                    }}
                  />
                ) : (
                  <SelectBox
                    label="Condition"
                    placeholder="Choose Condition"
                    options={conditionBuyxgetx}
                    value={values.condition_buy_x_get_x}
                    trackBy="value"
                    labelKey="label"
                    isRequired={true}
                    hasError={
                      errors.condition_buy_x_get_x &&
                      touched.condition_buy_x_get_x
                        ? errors.condition_buy_x_get_x
                        : null
                    }
                    onChange={(value) => {
                      setFieldValue(
                        'condition_buy_x_get_x',
                        conditionBuyxgetx.find((a) => a.value == value.value),
                      );
                      setFieldValue('maximum_qty_order_type', null);
                      resetGwpLeveling();
                      //reset all data related Qty/Min Purchase
                      resetQtyMinPurchase();
                      setFieldValue('purchased_product', '');
                      setFieldValue('qty_purchased_product', '');
                      setFieldValue('free_product', '');
                      setFieldValue('qty_free_product', '');
                      setFieldValue('tax_free_product', '');
                      setFieldValue('purchased_brand', '');
                      setFieldValue('minimum_purchase', '');
                    }}
                  />
                )}
              </>
              {values.promotion_model?.value == 'buy_x_get_x_and_buy_x_get_y' &&
              values.condition_buy_x_get_x.value === 'quantity_purchased' ? (
                <View style={{ width: '100%' }}>
                  <View style={styles.chooseRules}>
                    {/* Start Purchased Product Picker */}
                    <Layout.FormGroup>
                      {isWeb ? (
                        // Purchased Product Picker Desktop
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SociollaText
                            style={{
                              fontSize: 12,
                              marginBottom: 10,
                            }}>
                            Purchased Product
                          </SociollaText>
                          <SelectFormRules
                            type="product"
                            withoutResult
                            placeholder="Type product name"
                            value={selectedProduct}
                            onChange={(val) => {
                              setFieldTouched('purchased_product', false);
                              setFieldValue('purchased_product', val);
                              setSelectedProduct([val]);
                            }}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listProduct}
                            selectedBox={selectedBoxProduct}
                            setSelectedBox={(val) => setSelectedBoxProduct(val)}
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                          {selectedProduct?.length ? (
                            <View style={{ width: 350 }}>
                              {selectedProduct.map((item, idx) => (
                                <ProductResult
                                  product={item}
                                  onRemove={() => {
                                    setFieldValue('purchased_product', '');
                                    setSelectedProduct([]);
                                  }}
                                  key={idx}
                                />
                              ))}
                            </View>
                          ) : (
                            false
                          )}
                          <SociollaErrorMessage
                            visible={
                              errors.purchased_product &&
                              touched.purchased_product
                            }
                            error={errors.purchased_product}
                          />
                        </View>
                      ) : (
                        // Purchased Product Picker Mobile
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SelectProductV2
                            label="Purchased Product"
                            placeholder=""
                            value={
                              selectedProduct?.length ? selectedProduct[0] : {}
                            }
                            showVariant={false}
                            hasError={
                              errors.purchased_product &&
                              touched.purchased_product
                                ? errors.purchased_product
                                : null
                            }
                            onChange={(value) => {
                              const pr = {
                                id: value.id,
                                name: value.name,
                                brand: {
                                  id: value.brand?.id,
                                  name: value.brand?.name,
                                },
                                combination_id: value.combination?.id,
                                variant: value.combination?.attributes
                                  ? getAttibutes(value.combination.attributes)
                                  : '-',
                                sku: value.combination?.reference
                                  ? value.combination.reference
                                  : '-',
                                image: value.combination?.images?.length
                                  ? value.combination.images[0].url
                                  : '',
                                quantity: 1,
                              };
                              setFieldTouched('purchased_product', false);
                              setFieldValue('purchased_product', pr);
                              setSelectedProduct([pr]);
                            }}
                          />
                        </View>
                      )}
                      {/* Quantity Purchased Product */}
                      <View style={{ maxWidth: 195 }}>
                        <Input
                          label="Quantity Purchased Product"
                          value={
                            values.qty_purchased_product
                              ? values.qty_purchased_product
                              : ''
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.qty_purchased_product &&
                            touched.qty_purchased_product
                              ? errors.qty_purchased_product
                              : null
                          }
                          onChangeText={handleChange('qty_purchased_product')}
                        />
                      </View>
                    </Layout.FormGroup>
                    {/* End Purchased Product Picker */}
                    {/* Start Free Product Picker */}
                    <Layout.FormGroup>
                      {isWeb ? (
                        // Free Product Picker Desktop
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SociollaText
                            style={{
                              fontSize: 12,
                              marginBottom: 10,
                            }}>
                            Free Product
                          </SociollaText>
                          <SelectFormRules
                            type="free_product"
                            withoutResult
                            placeholder="Type product name"
                            value={[selectedFreeProduct]}
                            onChange={(val) => {
                              setFieldTouched('free_product', false);
                              setFieldValue('free_product', val);
                              setSelectedFreeProduct(val);
                            }}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listFreeProduct}
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                          {selectedFreeProduct?.id ? (
                            <View style={{ width: 350 }}>
                              <ProductResult
                                product={selectedFreeProduct}
                                onRemove={() => {
                                  setFieldValue('free_product', '');
                                  setSelectedFreeProduct({});
                                }}
                              />
                            </View>
                          ) : (
                            false
                          )}
                          <SociollaErrorMessage
                            visible={
                              errors.free_product && touched.free_product
                            }
                            error={errors.free_product}
                          />
                        </View>
                      ) : (
                        // Free Product Picker Mobile
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SelectProductV2
                            label="Free Product"
                            placeholder=""
                            value={
                              selectedFreeProduct?.id ? selectedProduct[0] : {}
                            }
                            showVariant={false}
                            hasError={
                              errors.free_product && touched.free_product
                                ? errors.free_product
                                : null
                            }
                            onChange={(value) => {
                              const pr = {
                                id: value.id,
                                name: value.name,
                                brand: {
                                  id: value.brand?.id,
                                  name: value.brand?.name,
                                },
                                combination_id: value.combination?.id,
                                variant: value.combination?.attributes
                                  ? getAttibutes(value.combination.attributes)
                                  : '-',
                                sku: value.combination?.reference
                                  ? value.combination.reference
                                  : '-',
                                image: value.combination?.images?.length
                                  ? value.combination.images[0].url
                                  : '',
                                quantity: 1,
                              };
                              setFieldTouched('free_product', false);
                              setFieldValue('free_product', pr);
                              setSelectedFreeProduct(pr);
                            }}
                          />
                        </View>
                      )}
                      {/* Quantity Free Product */}
                      <View style={{ maxWidth: 195, marginBottom: 10 }}>
                        <Input
                          label="Quantity Free Product"
                          value={
                            values.qty_free_product
                              ? values.qty_free_product
                              : ''
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.qty_free_product && touched.qty_free_product
                              ? errors.qty_free_product
                              : null
                          }
                          onChangeText={handleChange('qty_free_product')}
                        />
                      </View>
                      {/* Tax Free Product */}
                      <View
                        style={{
                          maxWidth: 195,
                          paddingRight: 20,
                          position: 'relative',
                        }}>
                        <Input
                          label="Tax Free Product"
                          value={
                            values.tax_free_product
                              ? values.tax_free_product
                              : 0
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.tax_free_product && touched.tax_free_product
                              ? errors.tax_free_product
                              : null
                          }
                          onChangeText={handleChange('tax_free_product')}
                        />
                        <SociollaText
                          style={{
                            position: 'absolute',
                            right: 0,
                            top: 30,
                          }}>
                          %
                        </SociollaText>
                      </View>
                    </Layout.FormGroup>
                    {/* End Free Product Picker */}
                  </View>
                </View>
              ) : (
                false
              )}

              {/* minimum purchased */}
              {values.promotion_model?.value == 'buy_x_get_x_and_buy_x_get_y' &&
              values.condition_buy_x_get_x.value === 'minimum_purchased' ? (
                <View style={{ width: '100%' }}>
                  <View style={styles.chooseRules}>
                    {/* Start Purchased Product Picker */}
                    <Layout.FormGroup>
                      {isWeb ? (
                        // Purchased Product Picker Desktop
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SociollaText
                            style={{
                              fontSize: 12,
                              marginBottom: 10,
                            }}>
                            Purchased Brand
                          </SociollaText>
                          <SelectFormRules
                            type="brand"
                            withoutResult
                            placeholder="Type brand name"
                            value={selectedBrand}
                            onChange={(val) => {
                              setFieldTouched('purchased_brand', false);
                              setFieldValue('purchased_brand', val);
                              setSelectedBrand([val]);
                            }}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listBrand}
                            selectedBox={selectedBoxBrand}
                            setSelectedBox={(val) => setSelectedBoxBrand(val)}
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                          {selectedBrand?.length ? (
                            <View style={{ width: 350 }}>
                              {selectedBrand.map((item, idx) => (
                                <ProductResult
                                  product={item}
                                  onRemove={() => {
                                    setFieldValue('purchased_brand', '');
                                    setSelectedBrand([]);
                                  }}
                                  key={idx}
                                />
                              ))}
                            </View>
                          ) : (
                            false
                          )}
                          <SociollaErrorMessage
                            visible={
                              errors.purchased_brand && touched.purchased_brand
                            }
                            error={errors.purchased_brand}
                          />
                        </View>
                      ) : (
                        // Purchased Product Picker Mobile
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SelectProductV2
                            label="Purchased Brand"
                            placeholder=""
                            value={
                              selectedBrand?.length ? selectedBrand[0] : {}
                            }
                            showVariant={false}
                            hasError={
                              errors.purchased_brand && touched.purchased_brand
                                ? errors.purchased_brand
                                : null
                            }
                            onChange={(value) => {
                              const pr = {
                                id: value.id,
                                name: value.name,
                                brand: {
                                  id: value.brand?.id,
                                  name: value.brand?.name,
                                },
                                combination_id: value.combination?.id,
                                variant: value.combination?.attributes
                                  ? getAttibutes(value.combination.attributes)
                                  : '-',
                                sku: value.combination?.reference
                                  ? value.combination.reference
                                  : '-',
                                image: value.combination?.images?.length
                                  ? value.combination.images[0].url
                                  : '',
                                quantity: 1,
                              };
                              setFieldTouched('purchased_brand', false);
                              setFieldValue('purchased_brand', pr);
                              setSelectedBrand([pr]);
                            }}
                          />
                        </View>
                      )}
                      {/* Quantity Purchased Product */}
                      <View style={{ maxWidth: 195 }}>
                        <Input
                          label="Minimum Purchased Brand"
                          value={
                            values.minimum_purchase
                              ? values.minimum_purchase
                              : ''
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.minimum_purchase && touched.minimum_purchase
                              ? errors.minimum_purchase
                              : null
                          }
                          onChangeText={handleChange('minimum_purchase')}
                        />
                      </View>
                    </Layout.FormGroup>
                    {/* End Purchased Product Picker */}
                    {/* Start Free Product Picker */}
                    <Layout.FormGroup>
                      {isWeb ? (
                        // Free Product Picker Desktop
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SociollaText
                            style={{
                              fontSize: 12,
                              marginBottom: 10,
                            }}>
                            Free Product
                          </SociollaText>
                          <SelectFormRules
                            type="free_product"
                            withoutResult
                            placeholder="Type product name"
                            value={[selectedFreeProduct]}
                            onChange={(val) => {
                              setFieldTouched('free_product', false);
                              setFieldValue('free_product', val);
                              setSelectedFreeProduct(val);
                            }}
                            showList={showList}
                            searchKeyword={searchKeyword}
                            isLoading={isLoading}
                            isLoadingMore={isLoadingMore}
                            isEmpty={isEmpty}
                            lists={listFreeProduct}
                            setShowList={(val) => setShowList(val)}
                            setSearchType={(val) => setSearchType(val)}
                            setSearchKeyword={(val) => setSearchKeyword(val)}
                            setSkip={(val) => setSkip(val)}
                            setRulesType={(val) => setRulesType(val)}
                            setIsLoadingMore={(val) => setIsLoadingMore(val)}
                            onSearch={({ type, value }) => {
                              setShowList({
                                ...showList,
                                [type]: true,
                              });
                              setSearchType(type);
                              setSearchKeyword({
                                ...searchKeyword,
                                [type]: value,
                              });
                              setSkip({
                                ...skip,
                                [type]: 0,
                              });
                              onSearchRules(type, value);
                            }}
                            onLoadMore={(type) => {
                              setRulesType(type);
                              setSkip({
                                ...skip,
                                [type]: skip[type] + 10,
                              });
                              setIsLoadingMore({
                                ...isLoadingMore,
                                [type]: true,
                              });
                            }}
                          />
                          {selectedFreeProduct?.id ? (
                            <View style={{ width: 350 }}>
                              <ProductResult
                                product={selectedFreeProduct}
                                onRemove={() => {
                                  setFieldValue('free_product', '');
                                  setSelectedFreeProduct({});
                                }}
                              />
                            </View>
                          ) : (
                            false
                          )}
                          <SociollaErrorMessage
                            visible={
                              errors.free_product && touched.free_product
                            }
                            error={errors.free_product}
                          />
                        </View>
                      ) : (
                        // Free Product Picker Mobile
                        <View
                          style={{
                            width: '100%',
                            marginBottom: 10,
                          }}>
                          <SelectProductV2
                            label="Free Product"
                            placeholder=""
                            value={
                              selectedFreeProduct?.id ? selectedProduct[0] : {}
                            }
                            showVariant={false}
                            hasError={
                              errors.free_product && touched.free_product
                                ? errors.free_product
                                : null
                            }
                            onChange={(value) => {
                              const pr = {
                                id: value.id,
                                name: value.name,
                                brand: {
                                  id: value.brand?.id,
                                  name: value.brand?.name,
                                },
                                combination_id: value.combination?.id,
                                variant: value.combination?.attributes
                                  ? getAttibutes(value.combination.attributes)
                                  : '-',
                                sku: value.combination?.reference
                                  ? value.combination.reference
                                  : '-',
                                image: value.combination?.images?.length
                                  ? value.combination.images[0].url
                                  : '',
                                quantity: 1,
                              };
                              setFieldTouched('free_product', false);
                              setFieldValue('free_product', pr);
                              setSelectedFreeProduct(pr);
                            }}
                          />
                        </View>
                      )}
                      {/* Quantity Free Product */}
                      <View style={{ maxWidth: 195, marginBottom: 10 }}>
                        <Input
                          label="Quantity Free Product"
                          value={
                            values.qty_free_product
                              ? values.qty_free_product
                              : ''
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.qty_free_product && touched.qty_free_product
                              ? errors.qty_free_product
                              : null
                          }
                          onChangeText={handleChange('qty_free_product')}
                        />
                      </View>
                      {/* Tax Free Product */}
                      <View
                        style={{
                          maxWidth: 195,
                          paddingRight: 20,
                          position: 'relative',
                        }}>
                        <Input
                          label="Tax Free Product"
                          value={
                            values.tax_free_product
                              ? values.tax_free_product
                              : 0
                          }
                          keyboardType="numeric"
                          isNumeric={true}
                          hasError={
                            errors.tax_free_product && touched.tax_free_product
                              ? errors.tax_free_product
                              : null
                          }
                          onChangeText={handleChange('tax_free_product')}
                        />
                        <SociollaText
                          style={{
                            position: 'absolute',
                            right: 0,
                            top: 30,
                          }}>
                          %
                        </SociollaText>
                      </View>
                    </Layout.FormGroup>
                    {/* End Free Product Picker */}
                  </View>
                </View>
              ) : (
                false
              )}
              {values.promotion_model?.value == 'buy_x_get_x_and_buy_x_get_y' &&
              values.condition_buy_x_get_x.value === 'gwp_leveling' ? (
                <View
                  style={{
                    width: isWeb ? '90%' : '100%',
                    marginLeft: isWeb ? 20 : 0,
                    marginTop: 10,
                  }}>
                  {/* Minimum Requirements & Purchase Product by */}
                  <View
                    style={{
                      height: 250,
                      borderColor: '#BDC1C9',
                      borderWidth: 1,
                      borderRadius: 12,
                      display: 'flex',
                      paddingHorizontal: 15,
                    }}>
                    <View
                      style={{
                        height: '49%',
                        borderBottomColor: '#BDC1C9',
                        borderBottomWidth: 1,
                      }}>
                      <SociollaText
                        type={isWeb ? 'medium' : 'regular'}
                        style={{
                          color: '#7D838F',
                          fontSize: isWeb ? 13 : 11,
                          marginVertical: isWeb ? 15 : 10,
                        }}>
                        Minimum Requirements
                      </SociollaText>
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems:
                            gwpLevelingData.minimum_requirement !== 'amount'
                              ? 'flex-end'
                              : 'flex-start',
                        }}>
                        <RadioButton
                          orientation="vertical"
                          value={gwpLevelingData.minimum_requirement}
                          data={minimumRequirementOptions}
                          onChange={(value) => {
                            setGwpLevelingData((prevState) => ({
                              ...prevState,
                              minimum_requirement: value,
                            }));

                            setFieldValue('gwp_levelling_min_quantity', '');
                            setFieldValue('gwp_levelling_min_amount', '');

                            setLevelProductGwp((prev) => ({
                              purchaseProduct: prev.purchaseProduct.map(
                                (lvl) => ({
                                  ...lvl,
                                  items: lvl.items.map((it) => ({
                                    ...it,
                                    quantity: 0,
                                  })),
                                }),
                              ),
                              freeProduct: prev.freeProduct.map((lvl) => ({
                                ...lvl,
                                items: lvl.items.map((it) => ({
                                  ...it,
                                  quantity: 0,
                                })),
                              })),
                            }));
                          }}
                        />
                        {gwpLevelingData.minimum_requirement === 'amount' ? (
                          <View
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: 3,
                              marginLeft: 20,
                              backgroundColor: '#FFFFFF',
                            }}>
                            <Input
                              style={{
                                width: isWeb ? 150 : 90,
                              }}
                              value={
                                values.gwp_levelling_min_amount
                                  ? values.gwp_levelling_min_amount
                                  : ''
                              }
                              keyboardType="numeric"
                              isNumeric={true}
                              onChangeText={handleChange(
                                'gwp_levelling_min_amount',
                              )}
                            />
                          </View>
                        ) : (
                          false
                        )}
                        {gwpLevelingData.minimum_requirement === 'quantity' ? (
                          <View
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              marginBottom: 3,
                              marginLeft: 20,
                              backgroundColor: '#FFFFFF',
                            }}>
                            <Input
                              style={{
                                width: isWeb ? 150 : 90,
                              }}
                              value={
                                values.gwp_levelling_min_quantity
                                  ? values.gwp_levelling_min_quantity
                                  : ''
                              }
                              keyboardType="numeric"
                              isNumeric={true}
                              onChangeText={handleChange(
                                'gwp_levelling_min_quantity',
                              )}
                            />
                          </View>
                        ) : (
                          false
                        )}
                      </View>
                    </View>
                    <View
                      style={{
                        height: '51%',
                      }}>
                      <SociollaText
                        type={isWeb ? 'medium' : 'regular'}
                        style={{
                          color: '#7D838F',
                          fontSize: isWeb ? 13 : 11,
                          marginVertical: isWeb ? 15 : 10,
                        }}>
                        Purchase Product by
                      </SociollaText>
                      <RadioButton
                        orientation="vertical"
                        value={gwpLevelingData.purchase_product_by}
                        data={purchaseProductByOptions}
                        onChange={(value) => {
                          setGwpLevelingData((prevState) => ({
                            ...prevState,
                            purchase_product_by: value,
                          }));

                          resetLevels();
                        }}
                      />
                    </View>
                  </View>
                  {/* Purchase Product & Free Product */}
                  {gwpLevelingData.purchase_product_by ? (
                    <View>
                      <View
                        style={{
                          marginTop: 15,
                          // minHeight: 250,
                          borderColor: '#BDC1C9',
                          borderWidth: 1,
                          borderRadius: 12,
                          display: 'flex',
                          paddingHorizontal: 15,
                          paddingBottom: 15,
                        }}>
                        <SociollaText
                          type={isWeb ? 'medium' : 'regular'}
                          style={{
                            color: '#7D838F',
                            fontSize: isWeb ? 13 : 11,
                            marginVertical: isWeb ? 15 : 10,
                          }}>
                          Purchase Product
                        </SociollaText>
                        <View
                          style={{
                            height: 1,
                            borderBottomColor: '#BDC1C9',
                            borderBottomWidth: 1,
                            width: '100%',
                          }}
                        />
                        {renderSection({
                          sectionType: 'purchaseProduct',
                          levels: levelProductGwp.purchaseProduct,
                          gwpLevelingData,
                          isWeb,
                          listProduct: listPurchaseProductGwp,
                          listBrand: listBrandGwp,
                          setLevelItems,
                          setLevelUi,
                          onSearchRules,
                          setListProduct: setListPurchaseProductGwp,
                          setListBrand: setListBrandGwp,
                          addDefaultLevelGwp,
                          type: gwpLevelingData.purchase_product_by,
                        })}
                      </View>
                      <View
                        style={{
                          marginTop: 15,
                          // minHeight: 250,
                          borderColor: '#BDC1C9',
                          borderWidth: 1,
                          borderRadius: 12,
                          display: 'flex',
                          paddingHorizontal: 15,
                          paddingBottom: 15,
                        }}>
                        <SociollaText
                          type={isWeb ? 'medium' : 'regular'}
                          style={{
                            color: '#7D838F',
                            fontSize: isWeb ? 13 : 11,
                            marginVertical: isWeb ? 15 : 10,
                          }}>
                          Free Product
                        </SociollaText>
                        <View
                          style={{
                            height: 1,
                            borderBottomColor: '#BDC1C9',
                            borderBottomWidth: 1,
                            width: '100%',
                          }}
                        />
                        {renderSection({
                          sectionType: 'freeProduct',
                          levels: levelProductGwp.freeProduct,
                          gwpLevelingData,
                          isWeb,
                          listProduct: listFreeProductGwp,
                          listBrand: listBrandGwp,
                          setLevelItems,
                          setLevelUi,
                          onSearchRules,
                          setListProduct: setListFreeProductGwp,
                          setListBrand: setListBrandGwp,
                          addDefaultLevelGwp,
                          type: 'free_product',
                        })}
                      </View>
                    </View>
                  ) : (
                    false
                  )}
                </View>
              ) : (
                false
              )}
              {/* end minimum purchases */}
            </Layout.FormGroup>
          ) : (
            false
          )}
        </View>
        <View style={[styles.sectionContainer, styles.sectionBorder]}>
          <SociollaText
            type={isWeb ? 'medium' : 'regular'}
            style={[styles.sectionTitle, { color: Colors.blue0 }]}>
            Limit Promo
          </SociollaText>
          {/* Start Number of Transaction */}
          <Layout.FormGroup>
            <View style={{ maxWidth: 195 }}>
              <Input
                label="Number of Transactions"
                value={
                  values.no_of_transactions ? values.no_of_transactions : ''
                }
                keyboardType="numeric"
                isNumeric={true}
                hasError={
                  errors.no_of_transactions && touched.no_of_transactions
                    ? errors.no_of_transactions
                    : null
                }
                onChangeText={handleChange('no_of_transactions')}
              />
            </View>
          </Layout.FormGroup>
          {/* End Number of Transaction */}
          {/* Start Max Applied per Customer */}
          <Layout.FormGroup>
            <View style={{ maxWidth: 195 }}>
              <Input
                label="Max Applied per Customer"
                value={
                  values.maximum_applied_per_customer
                    ? values.maximum_applied_per_customer
                    : ''
                }
                keyboardType="numeric"
                isNumeric={true}
                hasError={
                  errors.maximum_applied_per_customer &&
                  touched.maximum_applied_per_customer
                    ? errors.maximum_applied_per_customer
                    : null
                }
                onChangeText={handleChange('maximum_applied_per_customer')}
              />
            </View>
          </Layout.FormGroup>
          {/* End Max Applied per Customer */}
          {/* Start Max Quantity Order (Buy x Get X only) */}
          {values.promotion_model?.value == 'buy_x_get_x_and_buy_x_get_y' ? (
            <Layout.FormGroup>
              <View style={{ maxWidth: 195 }}>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: isWeb ? 'row' : 'column',
                    gap: 20,
                    alignItems: isWeb ? 'flex-end' : 'flex-start',
                  }}>
                  <Input
                    label="Max Quantity Free Product"
                    value={
                      values.maximum_qty_order ? values.maximum_qty_order : ''
                    }
                    keyboardType="numeric"
                    isNumeric={true}
                    hasError={
                      errors.maximum_qty_order && touched.maximum_qty_order
                        ? errors.maximum_qty_order
                        : null
                    }
                    onChangeText={handleChange('maximum_qty_order')}
                  />
                  {values.condition_buy_x_get_x.value === 'gwp_leveling' ? (
                    <View
                      style={{
                        bottom: 0,
                      }}>
                      <SelectBox
                        hideLabel={true}
                        hideSearch={true}
                        isTransparent={true}
                        options={MAX_QUANTITY_FREE_PRODUCTS}
                        value={values.maximum_qty_order_type}
                        trackBy="value"
                        labelKey="name"
                        hasError={
                          errors.maximum_qty_order_type &&
                          touched.maximum_qty_order_type
                            ? errors.maximum_qty_order_type
                            : null
                        }
                        onChange={(value) => {
                          setFieldValue('maximum_qty_order_type', value);
                        }}
                      />
                    </View>
                  ) : (
                    false
                  )}
                </View>
              </View>
            </Layout.FormGroup>
          ) : (
            false
          )}
          {values.promotion_model?.value == 'extra_discount' ? (
            <Layout.FormGroup>
              <View style={{ maxWidth: 195 }}>
                <BudgetPocketSearch
                  value={values.budget}
                  isRequired={true}
                  hasError={
                    errors.budget && touched.budget ? errors.budget : null
                  }
                  onChange={(value) => setFieldValue('budget', value)}
                  customFilter={{
                    current_status: 'approved',
                    is_active: true,
                    // start_date: { $lte: new Date().toISOString() },
                    end_date: { $gte: new Date().toISOString() },
                  }}
                />
              </View>
            </Layout.FormGroup>
          ) : (
            false
          )}
          {/* End Max Quantity Order (Buy x Get X only) */}
        </View>
      </>
    );
  };

  const getCustomerTypeValue = (isEdit, detailData, customerTypes) => {
    if (!isEdit) {
      return customerTypes[0];
    } // all

    const rules = detailData?.rules || {};

    if (rules.market_types?.length) {
      return customerTypes[1]; // specific_market_business_type
    }

    if (rules.customers?.length) {
      return customerTypes[2]; // specific_customer
    }

    if (rules.clusters?.length) {
      return customerTypes[3]; // specific_cluster
    }

    if (rules.customer_types?.length) {
      return customerTypes[4]; // specific_customer_type
    }

    return customerTypes[0]; // all
  };

  return (
    <Layout.Container>
      {(isEdit
        ? getPromotionRulesDetail.loading ||
          !(detailData && Object.keys(detailData).keys.length)
        : true) && !isReady ? (
        <Layout.Wrapper rounded>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (
        <Formik
          initialValues={{
            name: isEdit && detailData?.name ? detailData.name : '',
            description:
              isEdit && detailData?.description ? detailData.description : '',
            from_date:
              isEdit && detailData?.from_date
                ? new Date(detailData.from_date)
                : '',
            to_date:
              isEdit && detailData?.to_date ? new Date(detailData.to_date) : '',
            promotion_type:
              isEdit && detailData?.promotion_type
                ? {
                    name: promotionTypes[detailData.promotion_type],
                    value: detailData.promotion_type,
                  }
                : {
                    name: 'Trade Promo',
                    value: 'trade_promo',
                  },
            promotion_model:
              isEdit && detailData?.promotion_model
                ? {
                    name: promotionModels[detailData.promotion_model],
                    value: detailData.promotion_model,
                  }
                : '',
            is_active:
              isEdit && detailData?.is_active
                ? {
                    name: detailData.is_active ? 'Active' : 'Inactive',
                    value: detailData.is_active ? true : false,
                  }
                : { name: 'Inactive', value: false },
            current_status:
              isEdit && detailData?.current_status
                ? detailData.current_status
                : 'draft',
            no_of_transactions:
              isEdit && detailData?.no_of_transactions
                ? detailData.no_of_transactions
                : '',
            maximum_applied_per_customer:
              isEdit && detailData?.maximum_applied_per_customer
                ? detailData.maximum_applied_per_customer
                : '',
            maximum_qty_order:
              isEdit && detailData?.maximum_qty_order
                ? detailData.maximum_qty_order
                : '',
            maximum_qty_order_type:
              isEdit && detailData?.maximum_qty_order_type
                ? detailData.maximum_qty_order_type
                : '',
            cluster:
              isEdit && detailData?.discount_info?.cluster?.id
                ? {
                    id: detailData.discount_info.cluster.id,
                    name: detailData?.discount_info?.cluster?.name,
                  }
                : '',
            budget:
              isEdit && detailData?.budget?.id
                ? {
                    id: detailData?.budget?.id,
                    name: detailData?.budget?.name,
                  }
                : '',
            sales_team:
              isEdit && detailData?.rules?.sales_team?.length
                ? salesTeamTypes[1]
                : salesTeamTypes[0],
            selected_sales_team: isEdit ? detailData?.rules?.sales_team : [],
            selected_cluster: isEdit ? detailData?.rules?.clusters : [],
            customers: getCustomerTypeValue(isEdit, detailData, customerTypes),
            condition_buy_x_get_x: conditionGwp,
            product:
              isEdit &&
              (detailData?.rules?.brands?.length ||
                detailData?.rules?.categories?.length ||
                detailData?.rules?.products?.length)
                ? detailData?.rules?.brands?.length
                  ? productTypes[1]
                  : detailData?.rules?.categories?.length
                  ? productTypes[2]
                  : detailData?.rules?.products?.length
                  ? productTypes[3]
                  : productTypes[0]
                : productTypes[0],
            deduction_percentage:
              isEdit && detailData?.discount_info?.deduction_percentage
                ? detailData.discount_info.deduction_percentage
                : '',
            percentage_type:
              isEdit && detailData?.discount_info?.percentage_type
                ? ExtradiscountTypes.find(
                    (t) => t.value === detailData.discount_info.percentage_type,
                  ) || ExtradiscountTypes[0]
                : ExtradiscountTypes[0],
            first_order_deduction_percentage:
              isEdit &&
              detailData?.discount_info?.specific_order
                ?.first_order_deduction_percentage
                ? detailData.discount_info.specific_order
                    ?.first_order_deduction_percentage
                : '',
            next_order_deduction_percentage:
              isEdit &&
              detailData?.discount_info?.specific_order
                ?.next_order_deduction_percentage
                ? detailData.discount_info.specific_order
                    ?.next_order_deduction_percentage
                : '',
            discount_type: isEdit
              ? detailData?.discount_info?.deduction_percentage
                ? 'percentage'
                : 'amount'
              : 'percentage',
            qty_purchased_product:
              isEdit &&
              detailData?.rules?.products?.length &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
                ? detailData.rules.products[0].quantity
                : '',
            qty_free_product:
              isEdit &&
              detailData?.discount_info?.free_products?.id &&
              detailData?.discount_info?.free_products?.quantity &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
                ? detailData.discount_info.free_products.quantity
                : '',
            tax_free_product:
              isEdit &&
              detailData?.discount_info?.free_products?.id &&
              detailData?.discount_info?.free_products?.tax_value &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
                ? detailData.discount_info.free_products.tax_value
                : '',
            minimum_purchase:
              isEdit &&
              detailData?.discount_info?.free_products?.id &&
              detailData?.discount_info?.free_products?.quantity &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y' &&
              detailData?.rules?.brands.length
                ? detailData?.rules?.brands[0].minimum_purchase
                : '',
            purchased_product:
              isEdit &&
              detailData?.rules?.products?.length &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
                ? detailData.rules.products[0]
                : '',
            free_product:
              isEdit &&
              detailData?.discount_info?.free_products?.id &&
              detailData?.promotion_model == 'buy_x_get_x_and_buy_x_get_y'
                ? detailData.discount_info.free_products
                : '',
            gwp_levelling_min_quantity:
              isEdit && detailData?.rules?.gwp_levelling_min_quantity
                ? detailData?.rules?.gwp_levelling_min_quantity
                : '',
            gwp_levelling_min_amount:
              isEdit && detailData?.rules?.gwp_levelling_min_amount
                ? detailData?.rules?.gwp_levelling_min_amount
                : '',
            is_gwp_levelling:
              isEdit && detailData?.rules?.is_gwp_levelling
                ? detailData?.rules?.is_gwp_levelling
                : false,
          }}
          validationSchema={FormValidationSchema}
          onSubmit={handleSubmit}>
          {({
            handleChange,
            setFieldValue,
            setFieldTouched,
            validateForm,
            handleSubmit,
            errors,
            touched,
            values,
          }) => (
            <>
              {isWeb ? (
                <Layout.Wrapper white={false} fullWidth={true}>
                  <Layout.Back
                    title="Promotion Rules"
                    onCallback={() =>
                      isEdit
                        ? props.navigation.navigate(
                            'PromotionRulesDetailScreen',
                            props.route.params,
                          )
                        : props.navigation.navigate('PromotionRulesScreen')
                    }
                  />
                  <Layout.Title
                    title={`${isEdit ? 'Edit' : 'Add'} Promotion Rules`}>
                    <View style={{ flexDirection: 'row' }}>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 150, marginRight: 10 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            Save as Draft
                          </SociollaText>
                        }
                        onPress={(evt) => {
                          evt.persist();
                          setFieldValue('current_status', 'draft');
                          setTimeout(() => {
                            validateForm().then(() => {
                              handleSubmit(evt);
                            });
                          }, 100);
                        }}
                      />
                      <Button
                        rounded
                        buttonStyle={{ width: 150 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            Submit
                          </SociollaText>
                        }
                        onPress={(evt) => {
                          evt.persist();
                          setFieldValue('current_status', 'need_approval');
                          setTimeout(() => {
                            validateForm().then(() => {
                              handleSubmit(evt);
                            });
                          }, 100);
                        }}
                      />
                    </View>
                  </Layout.Title>
                </Layout.Wrapper>
              ) : (
                false
              )}
              <Layout.Wrapper rounded fullWidth={true}>
                <ScrollMobile
                  style={{
                    ...(isWeb ? {} : { height: windowHeight * 0.8 }),
                  }}>
                  <InfoForm
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />

                  {
                    // if promotion type and promotion model has been filled
                    values.promotion_type && values.promotion_model ? (
                      <>
                        <Layout.FormWrapper
                          style={{
                            width: isWeb
                              ? values.promotion_model?.value ==
                                'regular_discount'
                                ? '50%'
                                : '100%'
                              : '100%',
                            paddingVertical: 10,
                          }}>
                          <View
                            style={[
                              styles.sectionContainer,
                              styles.sectionBorder,
                            ]}>
                            <SociollaText
                              type={isWeb ? 'medium' : 'regular'}
                              style={[
                                styles.sectionTitle,
                                !isWeb ? { color: Colors.blue0 } : {},
                              ]}>
                              {
                                promotionTypes[
                                  values.promotion_type?.value
                                    ? values.promotion_type.value
                                    : values.promotion_type
                                ]
                              }{' '}
                              -{' '}
                              {
                                promotionModels[
                                  values.promotion_model?.value
                                    ? values.promotion_model.value
                                    : values.promotion_model
                                ]
                              }
                            </SociollaText>

                            {/* Regular Discount */}
                            <RegularAndCbd
                              values={values}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              handleChange={handleChange}
                            />
                          </View>
                          {/* Start Extra & Buy X Get X Discount */}
                          <ExtraAndBuyGet
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            setFieldTouched={setFieldTouched}
                          />
                          {/* End Extra & Buy X Get X Discount */}
                        </Layout.FormWrapper>
                      </>
                    ) : (
                      false
                    )
                  }
                </ScrollMobile>
              </Layout.Wrapper>
              {!isWeb ? (
                <View
                  style={[
                    buttonFloating,
                    {
                      borderTopColor: Colors.grey4,
                      marginBottom: isAndroid ? 0 : 0,
                    },
                  ]}>
                  <Button
                    rounded
                    title={
                      <SociollaText
                        type="bold"
                        style={{
                          fontSize: 14,
                          letterSpacing: 0.5,
                          color: Colors.white,
                        }}>
                        Submit
                      </SociollaText>
                    }
                    onPress={(evt) => {
                      evt.persist();
                      setFieldValue('current_status', 'need_approval');
                      setTimeout(() => {
                        validateForm().then(() => {
                          handleSubmit(evt);
                        });
                      }, 100);
                    }}
                  />
                </View>
              ) : (
                false
              )}
              {/* Popup Mobile */}
              {!isWeb ? (
                <ModalFull
                  title={titleModal}
                  show={showRules}
                  back={true}
                  width={650}
                  onClose={() => {
                    if (stepModal == 1) {
                      setShowRules('');
                      setRulesType('');
                    } else if (stepModal == 2) {
                      setStepModal(1);
                    } else if (stepModal == 3) {
                      setStepModal(2);
                    }
                  }}>
                  <View
                    style={{ width: '100%', height: dimension.height - 110 }}>
                    {stepModal == 1
                      ? listModal.map((item, idx) => (
                          <SelectItem
                            arrow={item.value != 'all'}
                            item={item}
                            onPress={() => {
                              if (item.value == 'all') {
                                setShowRules('');
                                setRulesType('');
                              } else {
                                setStepModal(2);
                              }
                              if (showRules == 'sales_team') {
                                if (item?.value != 'specific_sales_team') {
                                  setFieldValue('selected_sales_team', []);
                                }
                                setRulesType(item?.value);
                                setFieldValue(
                                  'sales_team',
                                  salesTeamTypes.find(
                                    (a) => a.value == item?.value,
                                  ),
                                );
                              } else if (showRules == 'customer') {
                                if (
                                  item?.value != 'specific_market_business_type'
                                ) {
                                  setSelectedMarketType({});
                                  setSelectedBusinessType([]);
                                }
                                if (item?.value == 'specific_customer') {
                                  setSelectedCustomer([]);
                                }
                                if (item?.value == 'specific_customer') {
                                  setSkip({ ...skip, customer: 0 });
                                  setSearchType('customer');
                                  onSearchRules(
                                    'customer',
                                    searchKeyword.customer,
                                    false,
                                    0,
                                    values,
                                  );
                                }
                                setRulesType(item?.value);
                                setFieldValue(
                                  'customers',
                                  customerTypes.find(
                                    (a) => a.value == item?.value,
                                  ),
                                );
                              } else if (showRules == 'product') {
                                if (item?.value != 'specific_brand') {
                                  setSelectedBrand([]);
                                }
                                if (item?.value != 'specific_categories') {
                                  setSelectedCategory([]);
                                }
                                if (item?.value != 'specific_product') {
                                  setSelectedProduct([]);
                                }
                                if (item?.value == 'specific_brand') {
                                  setSkip({ ...skip, brand: 0 });
                                  setSearchType('brand');
                                  onSearchRules('brand', searchKeyword.brand);
                                } else if (
                                  item?.value == 'specific_categories'
                                ) {
                                  setSkip({ ...skip, category: 0 });
                                  setSearchType('category');
                                  onSearchRules(
                                    'category',
                                    searchKeyword.category,
                                  );
                                } else if (item?.value == 'specific_product') {
                                  setSkip({ ...skip, product: 0 });
                                  setSearchType('product');
                                  onSearchRules(
                                    'product',
                                    searchKeyword.product,
                                  );
                                }
                                setRulesType(item?.value);
                                setFieldValue(
                                  'product',
                                  productTypes.find(
                                    (a) => a.value == item?.value,
                                  ),
                                );
                              }
                            }}
                            key={idx}
                          />
                        ))
                      : false}
                    {stepModal == 2 ? (
                      <>
                        {[
                          'specific_customer',
                          'specific_brand',
                          'specific_categories',
                          'specific_product',
                        ].includes(rulesType) ? (
                          <>
                            {['specific_customer', 'specific_product'].includes(
                              rulesType,
                            ) ? (
                              <View>
                                <ButtonUploadCSV
                                  type={
                                    rulesType === 'specific_customer'
                                      ? 'customer'
                                      : 'product'
                                  }
                                  onCallback={(val) => {
                                    const newValue =
                                      rulesType === 'specific_customer'
                                        ? selectedCustomer.concat(val)
                                        : selectedProduct.concat(val);

                                    if (rulesType === 'specific_customer') {
                                      setSelectedCustomer(newValue);
                                      setSelectedBoxCustomer(newValue);
                                    } else {
                                      setSelectedProduct(newValue);
                                      setSelectedBoxProduct(newValue);
                                    }
                                  }}
                                />
                                <View
                                  style={{
                                    width: '100%',
                                    paddingVertical: 3,
                                    flex: 1,
                                    alignItems: 'center',
                                  }}>
                                  <SociollaText
                                    type="medium"
                                    style={{
                                      fontSize: 10,
                                      color: Colors.grey0,
                                      letterSpacing: 0.5,
                                    }}>
                                    ------------------------ or
                                    --------------------------
                                  </SociollaText>
                                </View>
                              </View>
                            ) : (
                              false
                            )}
                            <SearchInputMobile
                              placeholder="Search by name"
                              onSearch={(value) =>
                                onSearchModal({ keyword: value, values })
                              }
                            />
                          </>
                        ) : (
                          false
                        )}
                        <ScrollContainer
                          style={{
                            width: '100%',
                            paddingTop:
                              rulesType == 'specific_market_business_type'
                                ? 0
                                : 10,
                          }}>
                          <RenderIf
                            condition={rulesType == 'specific_sales_team'}>
                            <SalesTeamSearch
                              hideLabel
                              multiple={true}
                              value={values.selected_sales_team}
                              onChange={(value) => {
                                setFieldValue('selected_sales_team', value);
                              }}
                              selectContainer={{ width: '100%' }}
                            />
                          </RenderIf>
                          <RenderIf condition={rulesType == 'specific_cluster'}>
                            <CustomerClusterSearch
                              hideLabel
                              value={values.selected_cluster}
                              onChange={(value) =>
                                setFieldValue('selected_cluster', value)
                              }
                              isRequired
                              multiple
                              selectContainer={{ width: '100%' }}
                            />
                          </RenderIf>
                          {[
                            'specific_customer',
                            'specific_brand',
                            'specific_categories',
                            'specific_product',
                          ].includes(rulesType) &&
                          isLoading[
                            rulesType == 'specific_customer'
                              ? 'customer'
                              : rulesType == 'specific_brand'
                              ? 'brand'
                              : rulesType == 'specific_categories'
                              ? 'category'
                              : 'product'
                          ] ? (
                            <Layout.Loader />
                          ) : [
                              'specific_customer',
                              'specific_brand',
                              'specific_categories',
                              'specific_product',
                            ].includes(rulesType) ? (
                            (rulesType == 'specific_customer'
                              ? listCustomer
                              : rulesType == 'specific_brand'
                              ? listBrand
                              : rulesType == 'specific_categories'
                              ? listCategory
                              : rulesType == 'specific_product'
                              ? listProduct
                              : listfiltered
                            ).map((item, idx) => (
                              <View
                                style={{
                                  width: '100%',
                                  paddingVertical: 5,
                                  paddingHorizontal: 15,
                                  marginBottom:
                                    rulesType == 'specific_product' ? 0 : 10,
                                  ...(rulesType == 'specific_product'
                                    ? {
                                        borderBottomWidth: 1,
                                        borderBottomColor: Colors.grey0,
                                      }
                                    : {}),
                                }}
                                key={idx}>
                                <CheckBox
                                  value={item.id}
                                  checked={
                                    (rulesType == 'specific_customer'
                                      ? selectedCustomer
                                      : rulesType == 'specific_brand'
                                      ? selectedBrand
                                      : rulesType == 'specific_categories'
                                      ? selectedCategory
                                      : rulesType == 'specific_product'
                                      ? selectedProduct
                                      : []
                                    ).findIndex((a) => a?.id == item?.id) > -1
                                  }
                                  onChange={(val) => {
                                    const oldVal = JSON.parse(
                                      JSON.stringify(
                                        rulesType == 'specific_customer'
                                          ? selectedCustomer
                                          : rulesType == 'specific_brand'
                                          ? selectedBrand
                                          : rulesType == 'specific_categories'
                                          ? selectedCategory
                                          : rulesType == 'specific_product'
                                          ? selectedProduct
                                          : [],
                                      ),
                                    );
                                    const index = oldVal.findIndex(
                                      (a) => a.id == val,
                                    );
                                    if (index > -1) {
                                      oldVal.splice(index, 1);
                                    } else {
                                      const res = (
                                        rulesType == 'specific_customer'
                                          ? listCustomer
                                          : rulesType == 'specific_brand'
                                          ? listBrand
                                          : rulesType == 'specific_categories'
                                          ? listCategory
                                          : rulesType == 'specific_product'
                                          ? listProduct
                                          : []
                                      ).find((a) => a.id == val);
                                      let allowed = true;
                                      if (rulesType == 'specific_customer') {
                                        allowed =
                                          selectedCustomer.findIndex(
                                            (a) => a.id == val,
                                          ) == -1;
                                      } else if (
                                        rulesType == 'specific_brand'
                                      ) {
                                        allowed =
                                          selectedBrand.findIndex(
                                            (a) => a.id == val,
                                          ) == -1;
                                      } else if (
                                        rulesType == 'specific_categories'
                                      ) {
                                        allowed =
                                          selectedCategory.findIndex(
                                            (a) => a.id == val,
                                          ) == -1;
                                      } else if (
                                        rulesType == 'specific_product'
                                      ) {
                                        allowed =
                                          selectedProduct.findIndex(
                                            (a) => a.id == val,
                                          ) == -1;
                                      }
                                      if (allowed) {
                                        oldVal.push(res);
                                      }
                                    }
                                    if (rulesType == 'specific_customer') {
                                      setSelectedCustomer(oldVal);
                                    } else if (rulesType == 'specific_brand') {
                                      setSelectedBrand(oldVal);
                                    } else if (
                                      rulesType == 'specific_categories'
                                    ) {
                                      setSelectedCategory(oldVal);
                                    } else if (
                                      rulesType == 'specific_product'
                                    ) {
                                      setSelectedProduct(oldVal);
                                    }
                                  }}>
                                  {rulesType == 'specific_product' ? (
                                    <ProductResult
                                      product={item}
                                      remove={false}
                                      border={false}
                                    />
                                  ) : (
                                    <SociollaText>{item.name}</SociollaText>
                                  )}
                                </CheckBox>
                              </View>
                            ))
                          ) : rulesType == 'specific_market_business_type' ? (
                            <>
                              {markettypes
                                .map((item) => {
                                  return { label: item.code, value: item.code };
                                })
                                .map((item, idx) => (
                                  <SelectItem
                                    arrow={true}
                                    item={item}
                                    onPress={() => {
                                      setBusinessTypeList([]);
                                      setSelectedBusinessType([]);
                                      const marketTypeResult = markettypes
                                        .map((item) => {
                                          return {
                                            id: item._id,
                                            code: item.code,
                                            label: item.code,
                                            value: item.code,
                                            business_type: item.business_type,
                                          };
                                        })
                                        .find((a) => a.value == item.value);
                                      if (marketTypeResult) {
                                        setSelectedMarketType(
                                          convertSelectedMarketType(
                                            marketTypeResult,
                                          ),
                                        );
                                        if (
                                          marketTypeResult?.business_type
                                            ?.length
                                        ) {
                                          setBusinessTypeList(
                                            marketTypeResult.business_type
                                              .filter((bt) => bt.is_active)
                                              .map((item) => {
                                                return convertBusinessType(
                                                  item,
                                                );
                                              }),
                                          );
                                        }
                                      }
                                      setStepModal(3);
                                    }}
                                    key={idx}
                                  />
                                ))}
                            </>
                          ) : (
                            false
                          )}
                        </ScrollContainer>
                      </>
                    ) : (
                      false
                    )}
                    {stepModal == 3 ? (
                      <View style={{ width: '100%', paddingTop: 15 }}>
                        {businessTypeList.map((item, idx) => (
                          <View
                            style={{
                              width: '100%',
                              paddingVertical: 5,
                              paddingHorizontal: 15,
                              marginBottom: 10,
                            }}
                            key={idx}>
                            <CheckBox
                              value={item.code}
                              checked={
                                selectedBusinessType.findIndex(
                                  (a) => a.code == item.code,
                                ) > -1
                              }
                              onChange={(val) => {
                                const oldVal = JSON.parse(
                                  JSON.stringify(selectedBusinessType),
                                );
                                const index = oldVal.findIndex(
                                  (a) => a.code == val,
                                );
                                if (index > -1) {
                                  oldVal.splice(index, 1);
                                  setSelectedBusinessType(oldVal);
                                } else {
                                  const res = businessTypeList.find(
                                    (a) => a.code == val,
                                  );
                                  oldVal.push(res);
                                  setSelectedBusinessType(oldVal);
                                }
                              }}>
                              <SociollaText>{item.code}</SociollaText>
                            </CheckBox>
                          </View>
                        ))}
                      </View>
                    ) : (
                      false
                    )}
                  </View>
                  {showRules &&
                  [2, 3].includes(stepModal) &&
                  (stepModal == 2
                    ? rulesType != 'specific_market_business_type'
                    : true) ? (
                    <View
                      style={[
                        buttonFloating,
                        {
                          position: isWebPlatform ? 'fixed' : 'absolute',
                          borderTopColor: Colors.grey0,
                          borderTopWidth: 1,
                        },
                      ]}>
                      <Button
                        rounded
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 16,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            Select
                          </SociollaText>
                        }
                        onPress={() => {
                          if (stepModal == 1) {
                            setStepModal(2);
                          } else if ([2, 3].includes(stepModal)) {
                            setStepModal(1);
                            setShowRules('');
                            setRulesType('');
                          }
                        }}
                      />
                    </View>
                  ) : (
                    false
                  )}
                </ModalFull>
              ) : (
                false
              )}
            </>
          )}
        </Formik>
      )}
      <Alert />
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: isWeb ? 15 : 13,
    marginVertical: isWeb ? 15 : 10,
    paddingHorizontal: 5,
  },
  sectionContainer: { width: '100%', paddingHorizontal: isWeb ? 20 : 15 },
  sectionBorder: !isWeb
    ? {
        borderTopColor: Colors.grey0,
        borderTopWidth: 1,
        paddingTop: 10,
        marginTop: 10,
      }
    : {},
  chooseRules: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: 30,
  },
  chooseRulesText: {
    width: '100%',
    fontSize: 13,
    color: Colors.grey1,
    marginTop: 15,
    marginBottom: 10,
  },
  addRange: {
    borderWidth: 1,
    borderRadius: 8,
    padding: 5,
  },
  infoFormWrapper: {
    paddingHorizontal: isWeb ? 20 : 15,
    ...(isWeb
      ? { paddingVertical: 20 }
      : {
          paddingTop: 20,
          paddingBottom: !isMobileWeb ? (isAndroid ? 140 : 80) : 0,
        }),
  },
  infoFormLeft: {
    width: isWeb ? '50%' : '100%',
    paddingRight: isWeb ? 30 : 0,
    ...(isWeb
      ? {
          borderRightColor: Colors.grey0,
          borderRightWidth: 1,
        }
      : {}),
  },
  infoFormRight: {
    width: isWeb ? '50%' : '100%',
    paddingLeft: isWeb ? 30 : 0,
  },
});

export default PromotionRulesFormScreen;
